/* ============================================================================
   assets/asf-index.js — sections/asf-index.liquid の全 JS（16 IIFE を出現順に連結）

   ★ なぜ別ファイルなのか（HOTFIX 2.5 / 2026-07-28）★
     Shopify は「テーマファイル 1 本 256KB」を強制する。asf-index.liquid は 303KB あり
     アップロードが拒否され、templates/index.json まで連鎖失敗した。
     → 5ビュー を snippets/asf-tab-*.liquid へ、JS 全量 を本ファイルへ退避した。
     中身は原本からの **逐語移送**（Liquid コメント `{%- comment -%}` は JS の
     ブロックコメントへ字面変換しただけ。ロジックは 1 文字も変えていない）。

   ★ 読み込み方 ★ セクション末尾で
       <script src="{{ 'asf-index.js' | asset_url }}" defer></script>
     defer は「HTML パース完了後・DOMContentLoaded の前」に実行される。
     layout/theme.liquid の永続スニペット 3 枚 + commerce-bridge はインライン＝パース中に
     asfBoot() へ登録されるので、**登録順は「layout の各スニペット → 本ファイル」のまま**
     （§(h) h-5 が要求する初期化順序が保存される）。asfBoot のキューは DOMContentLoaded で
     登録順に走るため、原本（セクション末尾のインライン script）と実行順は完全に同じ。

   ★ Liquid 由来の値 ★ .js は Liquid を通らない。よって Liquid でしか作れない値は
     すべてグローバル経由で受け取る:
       window.ASF_ROUTES  … layout/theme.liquid（root / cart / productHandles / …）
       window.ASF_MEDIA   … snippets/asf-media-urls.liquid（Shopify Files の CDN URL マップ）
       window.ASF_INDEX   … sections/asf-index.liquid 末尾のインラインブロック
                            （現状 videos[] のみ: id / mediaKey / poster）
     本ファイルに URL・ハンドルの直書きは一切無い（§(h) h-2 / h-6 の不変条件）。

   ★ 音の規律 ★ 背景・プレビュー動画は muted + volume=0 + playsinline + loop のまま。
     音を出すのは #videoModal（ユーザーがタイルを明示クリックした時）だけ — 原本どおり。
============================================================================ */

/* ==== [01] 原本 sections/asf-index.liquid L56-818 ==== */
/*
  [theme-v3 / Batch 1] ヘッダー走行ロゴ（カラクリ衝突マーキー）
  出典: demo-v3 index.html の同名 IIFE を **逐語移送**（ロジック無改変）。
  theme-v3 での唯一の変更は次の2点だけ:
    (1) window.asfBoot(...) で包む — このセクションは content_for_layout の中で描画され、
        demo のように </body> 直前で DOM が揃っている保証が無いため（§(h) h-5）。
    (2) window.__asfBootHeaderMarquee のシングルトン・ガード（二重マウント事故の構造的排除）。
  DOM 依存は .wordmark--marquee 配下のみ・アセット参照ゼロ・音源参照ゼロ。
*/
window.asfBoot(function(){
  if (window.__asfBootHeaderMarquee) return;
  window.__asfBootHeaderMarquee = true;

/* 2026-07-24(V) クライアント指示（大規模仕様変更・発動条件の完全反転・共通ブロック・対象11ページ単一値）。
   設計思想（クライアント指示原文）:「ユーザーはコンテンツが面白ければ画面を触る。だから触って
   いる間こそロゴが歩き、手を止めたら（読み終わり/離脱の瞬間に）衝突劇が起きる」。

   旧仕様（2026-07-21〜2026-07-24早期・約3日間運用）は発動条件が正反対だった:
     旧: 静止中=歩行／活動中=衝突（「操作すると驚いて追突する」体験）
     新: 活動中=歩行／静止中=衝突（「見入って手が止まると自動で追突劇が始まる」体験）
   旧仕様の詳細な設計判断履歴（[A]〜[K]、タスクB改2）は本ファイルのバージョン履歴に譲り、
   ここでは新仕様のみを正として記述する（同じ内容を2重に維持するとかえって可読性を損なう
   ため、今回は要約置換ではなく全面書き換えを選択・判断報告）。

   【新仕様の要点】
   ① 活動中（scroll/wheel/pointermove/pointerdown/touchstart/keydown・全て passive・
      既存リスナー群をそのまま流用）: 2体が一定ギャップ35px/sで通常追走（is-run・
      バウンス演出Aも同時発動）。活動が続く限り歩行を維持する。
   ② 活動が STILL_MS（採用値・後述）途絶えたら「静止」とみなし衝突シーケンスを起動:
      キューブをその場で凍結 → ASFはそのまま歩き続けてキューブに追突（① と全く同じ
      35px/sで「追いつく」— 既存 startApproach() を無改造で流用） → 潰れ&伸び(C) →
      跳ね返り46px(BOUNCE_GAP) → キューブ90度回転+めまい(D) → 両者静止（休憩状態）。
      衝突シーケンス自体の力学（接近距離の実測算出・スナップなし跳ね返り・回転蓄積・
      OFF/BASE_GAP/BOUNCE_GAPの数値と算出根拠）は無改変 — 発動条件（何がトリガーか）
      だけが反転しており、「キューブが止まってASFが追いつく」という物理的関係そのものは
      旧仕様から一貫している（旧: 活動開始をトリガーに同じ力学が起動していた）。
   ③ 再び活動が始まったら、休憩位置からそのまま歩行再開（跳ね返り位置が新しい基準
      ギャップになる・スナップなし — 既存 resume() の fold ロジックを無改造で流用）。
   ④ 衝突は1回の「静止期間」につき1回。次の「活動→静止」サイクルでまた1回。

   【実装方針の要点（判断報告）】
   [V-1] 既存資産の再利用範囲: 衝突力学そのもの（startApproach/startBounceAndRotate/
        pulseSquash/pulseStretch/startWobble/finishWobble/onApproachEnd/onBounceEnd/
        onCubeFallEnd と、その土台となる resume/freeze/trackX/currentWordX/wordRestX/
        startTrackAnimation/durMs/settleWordTransition）は一切変更していない。変更した
        のは「誰が・いつ」これらを呼ぶかという発火条件の層（旧 onActivity/arm を全面
        書き換え）のみ。これにより、直近3日間かけて実測・調整してきた接近速度・跳ね返り
        距離・OFF隠蔽計算・回転蓄積・独立トラック退場タイミングなどの物理設計は無傷で
        新モデルへそのまま移植できた（判断根拠: 「何をするか」と「いつするか」が既に
        きれいに分離された設計だったため、後者だけの差し替えで大規模な発動条件反転を
        安全に実現できた）。
   [V-2] STILL_MS（静止判定ディレイ）採用値: 1000ms（指示帯0.8〜1.5秒の中央）。
        判断根拠: 「読書中の自然な手離れ」という体感を狙う指示に対し、帯の下限寄り
        （0.8秒）は歩行→衝突の切り替わりが早すぎて「まだ読んでいるのに衝突が始まった」
        誤爆の体感リスクがあり、上限寄り（1.5秒）は手を止めてから反応までの間延び感が
        出るおそれがある。1.0秒はどちらの極端も避けたニュートラルな中央値であり、UI
        分野で一般的な「操作停止からの反応ディレイ」の目安（900ms〜1.2秒帯）とも整合する
        ため採用（作業ログに簡易実機確認記録あり）。
   [V-3]「活動の連続性ウィンドウ」は STILL_MS と同一値を採用（別途の値を設けない）。
        判断根拠: setTimeout の再武装（デバウンス）パターンでは、直近の活動から
        STILL_MS 未満の間隔で次の活動が来れば自動的にタイマーがリセットされ「継続中」
        として扱われる — これは「連続性ウィンドウ」が要求する挙動と数式的に同一であり、
        別の定数を新設すると「歩行を維持する猶予」と「衝突を起動する遅延」がズレて
        しまい、境界近辺で「まだ歩いているのに次の瞬間衝突判定が入る」ような矛盾した
        体感を生むリスクがある。単一の定数に統一する方がシンプルかつ挙動が一貫する。
   [V-4] 衝突シーケンス中に活動が再開した場合の挙動（判断根拠）: 「シーケンスを自然完了
        させてから歩行復帰」を採用（即時中断は不採用）。理由: 本サイトの「カラクリ
        （機械仕掛け）」という一貫したデザイン言語（衝突演出そのものの設計判断[A]参照・
        履歴コメントに詳述）は「一度動き出した機構は最後まで演じきる」ことに一貫して
        重きを置いてきた。approach/bounce/rotate/wobble のいずれかの中間状態で唐突に
        transform を差し替えて歩行へ戻すと、進行中の transition/animation と新しい
        animation-delay 計算が競合し視覚的な「ジャンプ」を生むリスクが高く、また
        「機械仕掛けが演技の途中で壊れて即座に歩き出す」という体験は「からくりの
        心地よさ」という指示原文の狙いに反する。衝突シーケンス自体は最長でも概ね
        4秒未満（内訳: 接近 最大約2.74秒[SP初回96px÷35px/s] + バウンド/回転 0.32秒 +
        めまい 0.5秒+保険0.15秒）で完結するため、「衝突中は次の活動を検知だけしておき、
        完了した瞬間に即座に歩行再開する」という設計（pendingResumeAfterCollision）で、
        待たせる時間を実務上ごく短く抑えつつ、視覚的な破綻を避けている。
   [V-5] 初期状態（ページロード直後・未操作）: 静止状態を維持（キューブは左端定位置に
        可視・ASFは wordRestX() により画面外で後方待機）。旧仕様が起動時に arm() を
        呼んで「無操作N秒後に歩行開始」の自動カウントダウンを仕込んでいたのに対し、
        新仕様は「歩行はユーザーの活動そのものが起点」という設計思想上、ロード直後に
        タイマーを仕込む必然性が無い（判断報告）— 初回の scroll/tap 等が来て初めて
        歩行が始まり、その後の最初の静止で初回衝突が起きる、という一連の「物語」が
        自然に成立する（初期化コード側の arm() 呼び出しを削除するだけで実現）。
   [V-6] 旧「キューブフリーズ+1秒でASF強制停止」（WORD_FREEZE_MS/forceFreezeWord）は
        撤去（クライアント指示）。旧仕様ではこのタイマーは「操作を続けているユーザーを
        あまり長く待たせない」ための応答性確保が目的だったが、新仕様では衝突シーケンスの
        トリガー自体が「ユーザーが操作をやめた瞬間」であるため、ユーザーは衝突の間まさに
        画面を見ていられる（見ている前提の演出）— 強制打ち切りの必要性そのものが消滅した
        （判断根拠は指示原文どおり）。代わりに、万一 transitionend/animationend が何らかの
        理由で発火しなかった場合に状態機械が永久に固まることを防ぐ、衝突シーケンス全体に
        対する緩い安全網（COLLISION_SAFETY_MS・下記 enterCollideMode 参照）を新設 — これは
        旧 WORD_FREEZE_MS のような「UX上の応答性を担保するタイミング機構」ではなく、
        純粋にイベント取りこぼし対策の保険であり、通常のフローでは一度も発火しない
        想定の値（かなり長め）を採用している。
   [V-7] reduced-motion・visibilitychange の扱い: サイト共通則「reduced-motion=常時静止」
        は無改変で維持（onActivity 冒頭のガード + change イベントでの完全リセットは
        新モデルでも同一の考え方で機能）。visibilitychange は「歩行中に復帰したら
        freeze→resumeで位相再アンカー」という技術的な必要性は新旧モデルで変わらず
        維持する一方、旧仕様にあった「歩行中でなければ arm() を再武装」という分岐は
        新モデルでは意味を失うため削除（新モデルでの歩行再開は常にユーザー活動が
        起点であり、タブの可視性復帰そのものはトリガーにならない — 判断報告）。
   OFF/BASE_GAP/BOUNCE_GAP等の数値・算出根拠、squash/stretch/wobble(C/D)の設計、
   display:blockベースライン修正、bottom:0接地、ASF16px/YYB24pxのサイズは本変更の対象外
   — すべて下記コードコメントおよびCSS側コメントに無改変で引き継がれている。 */
(function(){
  'use strict';
  /* ============================================================
     ヘッダー「追いかけっこ」マーキー v5 本体（2026-07-24(X) クライアント実地
     フィードバック反映）。「仮想トラック座標」アーキテクチャ（cubeVX を唯一の
     真実源とし、word の位置は wordVX = cubeVX - gap - wordWidth という代数的な
     恒等式のみで導出・DOM実測は静的サイズ取得以外に一切使わない）は v4
     （2026-07-24(W)）のまま無変更 — 詳細な設計判断・旧v3バグの真因は下記
     v4由来のコメントを参照。v5で変わるのは「gap の値そのもの」だけ:
     従来は固定96pxだったが、今回から静止のたびに 96→64→32→(接触4・衝突フル
     コース)→96(リセット) と段階的に詰まる「3段階接近ラダー」になった
     （LADDER_GAPS 配列 + rung インデックスで表現・下記 currentGap() 参照）。
     ラダーは固定定数の列であり動的計算・実測を一切伴わないため、周回テレポート
     に対する安全性は無条件に維持される。
     2026-07-24(Y) v6追加: 追走役をASFワードマークから「2号」(yyb-mark-2go.png・
     1号を180度回転した既存アセット・1号と完全同一サイズ)へ交代。変数名
     word/wordTrack/wordStretch は「後方の走者」という役割名のまま維持（アセット
     交代のみ・詳細はCSS側コメント参照）。位置計算の恒等式・仮想座標アーキテクチャ
     には一切変更なし（wordWidthは2号の実測幅へ自動追従するのみ）。新規に
     wordSpin（2号の衝突回転専用レイヤー）と chaserRotation（2号の累積回転角・
     1号と逆方向）を追加 — 詳細は各定義直上のコメント参照。
     2026-07-24(Z) v7 重大バグ修正: v6の wordSpin が「接近ダンスのtranslateXを
     持つ<img>自身」の**祖先**になっていたため、蓄積回転後は translateX が回転後
     座標系で解釈されて水平のはずの移動が垂直等に化ける不具合を確認・修正
     （症状「2号が上下に飛び出して消える」「1号2号が重なる」の根本原因・詳細は
     CSS側コメント参照）。接近ダンス(grace/hop/bounce-back)は新設の
     wordApproach（spin の**外側**＝祖先）へ完全移設 — word(<img>自身)は以後
     一切transformを持たない「純粋な絵」に徹する。あわせて視覚移動速度の上限
     （概ね100px/s）を満たすよう HOP_MS/BOUNCE_MS とイージングを再計算
     （詳細は各定数直上のコメント参照）、および描画されたギャップを毎フレーム
     監視する最終防衛ウォッチドッグ（watchdogTick）を追加。
     2026-07-24(AA) v8 演出順序の入替え（クライアント指示）: 衝突フルコースの
     発火順序を「潰れ/伸び→跳ね返り移動→90度回転(1号2号同時)→めまい」から
     「潰れ/伸び→90度回転(1号2号同時)→[跳ね返り移動∥めまい]（回転完了後に同時
     発火）」へ変更 — 体感としては「その場でクルッと回ってから、後ずさる」動きに
     なる（指示原文どおり）。回転の開始タイミングが1号2号で揃う仕組み・蓄積方向
     （1号+90/2号-90・無改変）・各演出の尺とイージング（ROTATE_MS=320ms・
     BOUNCE_MS=1600ms・BOUNCE_EASE・WOBBLE_MS=500ms）・速度上限（VELOCITY_CAP_PX_S）
     はすべて既存値のまま — 変更したのは呼び出し順序のみ（新しい連鎖:
     startImpact［潰れ/伸び発火→即startRotate起動］→onRotateEnd［startBounceBack
     とstartWobbleを同時発火］→onBounceEnd［finishFullCourse］。めまいは
     WOBBLE_MS=500msで跳ね返りBOUNCE_MS=1600msより確実に先に終わるため、状態機械の
     完了トリガーはonBounceEnd側に一本化し、めまい側(finishWobble)は見た目の
     後始末のみを担う）。
     判断報告（めまいの発火位置）: めまいを回転完了の直後に置き跳ね返りと併走させる
     案を採用（跳ね返り完了後まで遅らせる案は不採用）。理由: 「クルッと回った反動で
     ふらつく」という因果関係は、めまいが回転の直後に始まってこそ体感的に自然に
     成立する。跳ね返り完了後（1.6秒後）まで遅らせると、回転からめまいまでの間隔が
     不自然に開いてしまい「なぜ今ふらついたのか」が回転と結びつきにくくなる。また
     めまい(0.5s)は跳ね返り(1.6s)よりずっと短く跳ね返りの前半で終わるため、
     「回転の余韻としてのふらつき」と「後ずさる本体動作」が視覚的に競合すること
     もない（クライアント指示「余韻の自然さで判断・報告」に対する回答）。
     この並列化により衝突フルコースの合計尺は、直列だった旧順序の
     0.2(grace)+0.5(hop-contact)+1.6(bounce)+0.32(rotate)+0.5(wobble)=3.12秒 から、
     回転後は跳ね返りとめまいが並列になる新順序の
     0.2+0.5+0.32+max(1.6, 0.5)=2.62秒 へ短縮 — これに伴い COLLISION_SAFETY_MS
     を再計算した（下記同名定数直上のコメント参照）。既存の保証（存在連続性・
     レイヤー分離・速度上限・ラダーリセット・pendingResumeAfterApproachによる
     「シーケンス自然完了後に歩行復帰」・周回テレポート安全性・reduced-motion）は
     いずれも呼び出し順序に依存しない設計のため、本改訂による副作用はない
     （判断報告）。 */
  var mq = document.querySelector('.wordmark--marquee');
  if(!mq) return;
  var cubeTrack = mq.querySelector('.asf-marquee__track--cube');
  var wordTrack = mq.querySelector('.asf-marquee__track--word');
  var cube = cubeTrack && cubeTrack.querySelector('.asf-marquee__chase--yyb');
  var word = wordTrack && wordTrack.querySelector('.asf-marquee__chase--2go'); /* 2026-07-24(Y): 「2号」— 変数名 word/wordTrack は「後方(2番目)の走者」という役割名として維持（アセット交代のみ・詳細はCSS側コメント参照） */
  if(!cubeTrack || !wordTrack || !cube || !word) return;
  var cubeSquash = cubeTrack.querySelector('.asf-marquee__squash');
  var wordStretch = wordTrack.querySelector('.asf-marquee__stretch');
  var wordSpin = wordTrack.querySelector('.asf-marquee__spin'); /* 2026-07-24(Y) 新設: 2号の衝突回転専用レイヤー */
  var wordApproach = wordTrack.querySelector('.asf-marquee__approach'); /* 2026-07-24(Z) 新設: 2号の接近ダンス(grace/hop/bounce-back)専用レイヤー。
     spin の外側（祖先）に配置することで、spin の回転が wordApproach の translateX を
     再解釈してしまう不具合（v7で修正・詳細はCSS側コメント参照）を構造的に防ぐ。
     word(<img>自身)は以後どのtransformも持たない — 1要素1transformソースの原則を
     spin/approach/img の3層それぞれ単一責任に保つ。 */
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;

  /* ---- 定数（すべて単一の真実源・CSS側の対応コメントと必ず一致させること） ---- */
  /* 2026-07-24(X) 「3段階接近ラダー」: LADDER_GAPS[rung] が現在の静止/歩行時の
     ギャップ。rung は 0〜2 の「休止しうる段」を指し、rung===LADDER_GAPS.length-2
     (=2) の状態で次の静止が来ると、そのターゲットは LADDER_GAPS[3]=CONTACT_GAP
     （＝接触）— このときだけ既存の衝突フルコース（潰れ→跳ね返りで96へ復帰→
     90度転倒→めまい）へ接続し、完了でラダーを rung=0 へリセットする。1・2段目
     （rung 0→1, 1→2）は「短いホップで詰めて止まるだけ」— 次の活動でそのまま
     詰まったギャップを保って歩行再開し、次の静止で続きを詰める（採用値の根拠は
     コーディネーター指示・CSS側同名コメント参照）。 */
  var LADDER_GAPS = [96, 64, 32, 4];
  var CONTACT_GAP = LADDER_GAPS[LADDER_GAPS.length - 1]; /* 4 */
  var BASE_PX_S = 35;   /* 歩行速度（無改変） */
  var OFF = 184;         /* 隠蔽マージン。ラダー最大値がv4と同じ96のため再計算不要（根拠はCSS側同名コメント参照） */
  var STILL_MS = 700;    /* 2026-07-24(X): 150→700。採用理由・検証方法は次のコメント参照 */
  /* STILL_MS 採用根拠（コーディネーター指示・実地フィードバック対応）:
     ホイールの刻み間・トラックパッドのストローク間・フリック連打の合間の自然な
     間隔は実測でおおむね300〜500ms — これを「静止」と誤検知すると、操作中に
     何度も接近が発動してしまう（クライアント報告①）。指示帯600〜900msの中から
     700ms（中央値）を初期採用値とし、headless Chromeでホイール連続刻み・
     トラックパッド連続ストローク・タッチのフリック連打を模したイベント間隔
     （200〜450ms間隔で連続発火）を注入し「ジェスチャ中に is-frozen へ遷移しない
     こと」を確認した（実測結果は最終報告に記載）。700msで実ジェスチャ中の
     誤検知が発生しないことを確認できたため、指示帯の中央値のまま採用 —
     600ms寄りに詰める根拠（体感の向上）と900ms寄りに緩める根拠（誤検知の
     さらなる余裕)が拮抗するため、追加の微調整は行わずシンプルに中央値を採用
     （判断報告）。 */
  var GRACE_MS = 200;    /* キューブ停止後もASFが歩行速度のまま進む「気づいてない」猶予（35px/sそのまま＝速度上限内・v4から無変更） */
  /* 2026-07-24(Z) 視覚速度上限（VELOCITY_CAP_PX_S=概ね100px/s＝歩行速度の約3倍）
     採用に伴い HOP_MS/BOUNCE_MS を再計算。cubic-bezierイージングは「平均速度」
     ではなく「瞬間速度のピーク」が実際の見た目の速さを決めるため、各カーブの
     ピーク瞬間速度／平均速度の倍率（peak_mult）を数値積分で実測したうえで
     duration = peak_mult × distance_px ÷ VELOCITY_CAP_PX_S で必要最小値を逆算し、
     数%の安全マージンを載せて丸めた（実測手法・値は最終報告に記載）。
     2026-07-24(AB) ディレクター裁定（クライアント指示「跳ね返りが等速的でぶつかった
     衝撃を感じない・ビョーンと弾き飛ばされて欲しい」を受けた再設計）: 本上限は
     「移動（locomotion＝歩行 walking／ホップ hop）」にのみ適用する運用ルールへ明確化。
     衝突の衝撃イベント（跳ね返りの噴出＝startBounceBack冒頭の初速フェーズ）に限り、
     瞬間的にこの上限を超える速度を許可する — 条件は①水平方向のみ（垂直の飛び出し
     禁止・帯内厳守。実装上 translateX のみを操作するため構造的に保証）②等速の
     滑走ではなく減衰振動を伴うバネ的カーブであること（等速の速い滑りは「シュッ」
     という不気味な質感の真因であり、減衰振動を伴う衝撃はカートゥーン表現として
     自然、という判断）。歩行(startWalking)・ホップ(startHop/HOP_MS)は本上限の
     対象のまま無改変。実測ログは検証セクション（最終報告）参照。 */
  var VELOCITY_CAP_PX_S = 100; /* 「ゆるさ」の物理法則 — 歩行・ホップ等の移動（locomotion）に適用する上限。
     衝突の衝撃イベント（跳ね返りの初速フェーズ）はディレクター裁定により対象外（上記コメント参照） */
  var HOP_MS = 500;      /* 2026-07-24(X)新設→(Z)再計算: 350→500。ease-out(peak_mult実測1.718倍)・
     最大移動距離25px(rung0→1/1→2のホップ本体)で計算: 1.718×25÷100=0.4295s要 → 500msで
     ピーク速度≈85.9px/s（約14%マージン）。hop-contact(21px)はさらに余裕（≈72.2px/s）。
     ホップは「移動」区分のため VELOCITY_CAP_PX_S 上限の対象のまま無改変（2026-07-24(AB)）。 */
  var BOUNCE_EASE = 'linear'; /* 2026-07-24(AB) 再設計: 「ビョーン」= 初速の噴出→強い減速→
     オーバーシュート→減衰振動→着地、という単一のcubic-bezierでは表現できない
     多段カーブが必要なため、@keyframes asf-marquee-bounce-back 側に区間ごとの
     animation-timing-function を持たせる方式へ変更（CSS標準機能・区間ごとに
     カーブを差し替え可能）。よってJS側でanimationショートハンドへ渡すこの
     トップレベルのイージングは実質未使用の中立値（'linear'）— 各区間の実際の
     カーブは@keyframes側の各キーフレームブロックが個別に持つ（旧: 単一の
     緩いeaseOutBack cubic-bezier(.68,1.1,.82,1)・peak_mult実測1.618倍・
     オーバーシュート量0.24%はこの再設計で撤去）。var(--ease-karakuri) 自体は
     1号の90度回転（角速度のみ・px/s上限の対象外）で引き続き共有使用するため無改変。 */
  var BOUNCE_MS = 1000;  /* 2026-07-24(X)新設→(Z)再計算: 400→1600→2026-07-24(AB)再設計: 1600→1000。
     クライアント指示「総尺0.9〜1.2s帯（現行1.6sより短くテンポよく）」の範囲内で
     区切りの良い1000msを採用。内訳（@keyframes asf-marquee-bounce-back参照・
     いずれも28px起点・目標値-64px=絶対値としてはG=96の定位置）:
       0%(0ms) -> 12%(120ms): 28px→-8px・timing-function:linear。移動36px÷0.12s=
         300px/s一定＝クライアント指定「初速250〜350px/s帯」の中央値。noteworthy:
         当初 easeOutBack 系カーブ(cubic-bezier(.11,.72,.16,1))を検討したが、
         数値シミュレーション（Newton法でx→t解決→速度を数値微分）で瞬間ピーク
         速度を実測したところ t=0 直後に≈1957px/sへ跳ね上がる「瞬間移動」
         アーティファクトを検出（区間平均は300px/sでも大半の変位が最初の数msに
         集中し残りは足踏みして見える）— 採用値のlinearに変更し、区間内で常に
         厳密300px/sの一定速度になることをシミュレーションで確認済み（噴出の
         説得力はこの初速フェーズで決まるという指示に対応）。この区間のみ
         2026-07-24(AB)ディレクター裁定によりロコモーション上限100px/sの対象外。
       12%→45%(120-450ms): -8px→-58px・timing-function:cubic-bezier(0,0,.58,1)
         （標準ease-out系）。区間開始点で前区間の300px/sに近い≈259px/sから
         滑らかに減速し始め、区間終端に向けて速度がさらに落ちる「強い減速」の
         シミュレーション結果を確認（この区間だけease-in系カーブを充てると
         「区間終盤に速度が再加速して見える」不自然なアーティファクトが数値上
         現れたため、ease-out系に変更して解消— 判断根拠は検証ログ参照）。
       45%→58%(450-580ms): -58px→-73px・timing-function:cubic-bezier(.42,0,.58,1)
         （ease-in-out系）。オーバーシュートのピーク＝目標-64pxを9px通過
         （クライアント指定「6〜10px級」の範囲内）。オーバーシュート方向は常に
         -64pxよりさらに負＝1号からさらに離れる方向のみ（再接触リスクなし）。
       58%→72%(580-720ms): -73px→-60px・同cubic-bezier(.42,0,.58,1)。減衰振動
         1回目（目標を4px下回る側へ揺り戻し）。
       72%→86%(720-860ms): -60px→-67px・同cubic-bezier(.42,0,.58,1)。減衰振動
         2回目（目標を3px上回る側・振幅は1回目(9px)→2回目(3px)で縮小＝減衰）。
       86%→100%(860-1000ms): -67px→-64px・timing-function未指定＝外側animation
         ショートハンドのBOUNCE_EASE('linear')を継承。目標へ収束・着地
         （x(1000ms)=-64.0000px・誤差ゼロをシミュレーションで確認）。
     全区間を通じ瞬間速度は300px/s(初速)→259px/s→199px/s→160px/s→86px/s→21px/s
     と単調減少（数値シミュレーションで実測・検証ログ参照）— 「等速の速い滑り」
     ではなく物理的に自然な減衰プロファイルであることを確認済み。
     跳ね返りの目標が常にG=96の定位置という設計自体は無改変（デュレーション・
     イージング構造のみ再設計）。2026-07-24(AA)由来の発火タイミング
     （90度回転の完了後）はそのまま無改変。 */
  var ROTATE_MS = 320;   /* キューブ90度転倒（無改変・回転はpx/s上限の対象外）。2026-07-24(AA):
     発火タイミングを「跳ね返り完了後」から「潰れ/伸びの直後」（衝突フルコースの
     先頭側）へ変更 — 尺(320ms)・イージング(var(--ease-karakuri))・1号2号同時起動の
     仕組みは無改変。 */
  var WOBBLE_MS = 500;   /* めまい（無改変・CSS側 .5s と一致必須）。2026-07-24(AA): 発火起点
     （90度回転の完了＝transitionend）自体は無改変 — 変わったのは同時刻に2号の
     跳ね返り移動(BOUNCE_MS)も並行して始まる点のみ（詳細はonRotateEnd直上のコメント
     参照）。 */
  var COLLISION_SAFETY_MS = 4200; /* 2026-07-24(AA) 再計算: 演出順序の入替え（潰れ/伸び→回転→
     [跳ね返り∥めまい]）に伴い、回転後の跳ね返り(1.6s)とめまい(0.5s)が直列でなく
     並列で走るようになったため、想定最長アクション（衝突フルコース）の合計尺も
     0.2(grace)+0.5(hop-contact)+1.6(bounce)+0.32(rotate)+0.5(wobble)=3.12s
     （旧・直列合計）から
     0.2(grace)+0.5(hop-contact)+0.32(rotate)+max(1.6(bounce), 0.5(wobble))=2.62s
     （新・回転後は並列区間の最大値のみ加算）へ短縮。旧値5000msは3.12s×約1.603倍の
     余裕だったため、同じ約1.6倍の余裕比率を新しい合計尺に適用: 2.62s×1.6≈4.19s
     → 4200msに更新（ソフトホップは最大0.7sでさらに余裕大・無改変）。 */
  var MIN_VISUAL_GAP_WATCHDOG = 2; /* 2026-07-24(Z) 新設: 最終防衛ウォッチドッグの発火しきい値。
     意図的な接触点(CONTACT_GAP=4px)より厳密に小さい値にすることで、正常な接触
     シーケンスを誤検知しない（詳細は watchdogTick 直上のコメント参照）。 */

  var GRACE_PX = BASE_PX_S * GRACE_MS / 1000; /* 7px（v4から無変更） */

  /* ---- 状態 ---- */
  var state = 'rest';   /* 'rest' | 'walk' | 'approach' */
  var rung = 0;          /* 現在のラダー段（0〜2）。currentGap()=LADDER_GAPS[rung] */
  var actionReachesContact = false; /* このアクション開始時に captured: rung===2 なら今回の接近は接触→衝突フルコースへ接続する */
  var cubeVX = OFF;      /* 仮想トラック座標の唯一の真実源。walk中は毎フレーム更新、approach/rest中はその瞬間の値で固定される。
     初期値はOFF（0ではない）— wrapScreenX(OFF,W)=0 となり、キューブが「左端定位置（可視・静止）」から
     始まる仕様を満たす（vx=0はラップ周期の隠蔽開始点(-OFF)に対応するため、可視の定位置はvx=OFFが正しい）。 */
  var walkStartT = 0, walkStartVX = 0; /* walk中の cubeVX(t) = walkStartVX + BASE_PX_S*(t-walkStartT)/1000 を成立させる基準点 */
  var rafId = null;
  var wordWidth = 0;    /* word画像の実測幅（静的サイズ取得・下記 measureWordWidth 参照） */
  var stillTimer = null;
  var pendingResumeAfterApproach = false;
  var collisionSafetyTimer = null;
  var cubeRotation = 0; /* 累積回転角（1号）・mod しない・リセットしない（無改変） */
  var chaserRotation = 0; /* 2026-07-24(Y) 新設: 2号の累積回転角。1号とは逆方向(-90ずつ)に蓄積 —
     採用理由（判断報告）: 「1号は衝撃で前方につんのめる／2号はその反動で自分ごと逆に
     振れる」という対の物理表現のほうが、同方向に揃えるより2体が別々の力学で反応して
     いるように見え視覚的に判別しやすい（同方向だと単なる複製のように見えるリスクが
     ある）。1号同様 mod しない・リセットしない（衝突フルコース完了ごとに±90加算し
     続ける・4回で見た目上1周）。 */
  var lastActivity = 0;

  function currentGap(){ return LADDER_GAPS[rung]; }

  function measureWordWidth(){
    var w = word.getBoundingClientRect().width;
    if(w) wordWidth = w; /* レイアウト未確定(0)時は前回値を維持するガード */
    return wordWidth;
  }

  /* ---- 描画: 仮想座標 → 画面座標（modulo折り返し）→ transform書き込み ----
     ここだけが「仮想座標を画面に落とす」変換であり、ロジック側はこの関数の
     出力を一切参照しない（一方向の変換・逆算しない）。 */
  function wrapScreenX(vx, W){
    var cycle = W + OFF;
    if(cycle <= 0) return -OFF;
    var m = vx % cycle;
    if(m < 0) m += cycle;
    return m - OFF;
  }
  function renderTrack(el, vx){
    el.style.transform = 'translateX(' + wrapScreenX(vx, mq.clientWidth) + 'px)';
  }
  function renderRestFrame(){
    renderTrack(cubeTrack, cubeVX);
    renderTrack(wordTrack, cubeVX - currentGap() - wordWidth);
  }

  /* ---- 歩行（walk） ---- */
  function tick(now){
    if(state !== 'walk'){ rafId = null; return; }
    cubeVX = walkStartVX + BASE_PX_S * (now - walkStartT) / 1000;
    renderTrack(cubeTrack, cubeVX);
    renderTrack(wordTrack, cubeVX - currentGap() - wordWidth); /* 恒等式 — 歩行中は常にこの式のみでwordの位置を導出（実測しない）。gapは現在のラダー段の値 */
    rafId = requestAnimationFrame(tick);
  }
  function startWalking(){
    if(reduce && reduce.matches) return;
    state = 'walk';
    walkStartT = performance.now();
    walkStartVX = cubeVX; /* 直前の位置（rest=直前の停止位置 / approach完了=接近後の位置）から継ぎ目なく継続 */
    mq.classList.add('is-run');
    mq.classList.remove('is-frozen');
    if(rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(tick);
  }
  function currentCubeVXNow(){
    if(state !== 'walk') return cubeVX;
    return walkStartVX + BASE_PX_S * (performance.now() - walkStartT) / 1000;
  }
  function stopWalkingRAF(){
    if(rafId){ cancelAnimationFrame(rafId); rafId = null; }
  }

  /* ---- 静止デバウンス（STILL_MS=700・採用根拠は上記コメント参照） ---- */
  function armStill(){
    if(stillTimer) clearTimeout(stillTimer);
    stillTimer = setTimeout(function(){
      if(state === 'walk') enterApproach();
    }, STILL_MS);
  }

  /* ---- 接近アクション（ラダー1段ぶん） ----
     cubeVXをその瞬間の値で確定し、両トラックを「現在のラダー段の値」でピン留め
     （wordは cubeVX-currentGap()-wordWidth＝歩行を止めたのと同一の見た目）。
     以降のダンス（grace→hop→[soft-settle または 衝突フルコース]）はすべて
     word/cube 自身の <img> が持つ局所レイヤーの transform（トラック位置には
     一切手を加えない）で表現する — 二層構造は v4 のまま踏襲。 */
  function enterApproach(){
    if(state !== 'walk') return;
    var vx = currentCubeVXNow();
    stopWalkingRAF();
    state = 'approach';
    cubeVX = vx;
    measureWordWidth();
    actionReachesContact = (rung === LADDER_GAPS.length - 2); /* rung===2 のときだけ今回は接触→衝突フルコース */
    renderTrack(cubeTrack, cubeVX);
    renderTrack(wordTrack, cubeVX - currentGap() - wordWidth);
    mq.classList.remove('is-run');
    mq.classList.add('is-frozen');
    if(collisionSafetyTimer) clearTimeout(collisionSafetyTimer);
    collisionSafetyTimer = setTimeout(function(){
      /* 保険: animationend/transitionend の取りこぼし等でシーケンスが完了しない
         まま固まった場合のみ、状態機械を強制的に「このアクションの完了」へ倒す。
         通常フローでは発火しない想定。 */
      collisionSafetyTimer = null;
      forceSettle();
    }, COLLISION_SAFETY_MS);
    startGrace();
  }

  function setAnim(el, spec){
    /* 連続トリガー時も確実に再生させるための強制リフロー付きヘルパー */
    el.style.animation = '';
    void el.offsetWidth;
    el.style.animation = spec;
  }

  function startGrace(){
    /* 200ms・linear・0→7px（35px/sと同速度＝歩行との継ぎ目なし＝「気づいてない」・全段共通・v4から無変更）。
       2026-07-24(Z): word(<img>)ではなく wordApproach に対して発火する（v7根本修正・上記コメント参照）。 */
    setAnim(wordApproach, (GRACE_MS/1000) + 's linear 1 forwards asf-marquee-chase-grace');
    wordApproach.addEventListener('animationend', onGraceEnd);
  }
  function onGraceEnd(e){
    if(e.target !== wordApproach || e.animationName !== 'asf-marquee-chase-grace') return;
    wordApproach.removeEventListener('animationend', onGraceEnd);
    startHop();
  }
  function startHop(){
    /* 500ms固定・ease-out・「スッ…トン」（速度上限に合わせて再計算・上記HOP_MSコメント参照）。
       接触に到達する段(actionReachesContact)だけ hop-contact（7→28px）、それ以外は
       hop（7→32px）を使う。 */
    var animName = actionReachesContact ? 'asf-marquee-hop-contact' : 'asf-marquee-hop';
    setAnim(wordApproach, (HOP_MS/1000) + 's ease-out 1 forwards ' + animName);
    wordApproach.addEventListener('animationend', onHopEnd);
  }
  function onHopEnd(e){
    if(e.target !== wordApproach || (e.animationName !== 'asf-marquee-hop' && e.animationName !== 'asf-marquee-hop-contact')) return;
    wordApproach.removeEventListener('animationend', onHopEnd);
    if(actionReachesContact){
      startImpact(); /* 接触の瞬間＝「ドン」→ 衝突フルコースへ接続。2026-07-24(AA):
         旧startBounce()を「潰れ/伸び＋回転起動」(startImpact)と「跳ね返り移動」
         (startBounceBack)へ分割・発火順序を入替え（詳細は各関数直上のコメント・
         冒頭IIFEヘッダーコメントのv8参照） */
    } else {
      finishHop(); /* ソフトホップ完了 — 詰まったギャップのまま静止 or 歩行再開 */
    }
  }
  function finishHop(){
    if(state !== 'approach') return; /* 冪等ガード（安全網タイマーとの競合対策） */
    rung += 1;
    wordApproach.style.animation = ''; wordApproach.style.transform = '';
    renderTrack(wordTrack, cubeVX - currentGap() - wordWidth); /* 新しいラダー段の絶対位置を直接描画（測定・折り込み不要 — 恒等式のみ） */
    finishApproachAction();
  }
  function startImpact(){
    /* 2026-07-24(AA) 衝突フルコース新順序（クライアント指示・「その場でクルッと
       回ってから、後ずさる」）: 潰れ/伸び(この関数) → 1号・2号同時90度回転
       (startRotate・この関数の末尾から直接起動) → 回転完了後に跳ね返り移動と
       めまいを同時発火（onRotateEnd参照）。旧順序（潰れ/伸び→跳ね返り→回転→
       めまい）からの入替えで、各演出そのものの値・尺・イージング・速度上限
       （HOP_MS/BOUNCE_MS/BOUNCE_EASE/ROTATE_MS/WOBBLE_MS/VELOCITY_CAP_PX_S）は
       すべて無改変（変更したのは呼び出し順序のみ）。 */
    pulseSquash();  /* cube の潰れ(0.1s) — 接触の瞬間 */
    pulseStretch(); /* word の伸び(0.4s) — 潰れと同時刻に発火（BOUNCE_MSとは非連動・
       無改変。跳ね返り本体はこの直後に起動する回転が完了するまで発火しない —
       下記startRotate/onRotateEnd参照） */
    startRotate(); /* 「パタッ」— 潰れ/伸びの発火と同一フレームで回転を起動（新順序の核心） */
  }
  function pulseSquash(){
    if(!cubeSquash) return;
    cubeSquash.classList.remove('is-pulse');
    void cubeSquash.offsetWidth;
    cubeSquash.classList.add('is-pulse');
  }
  function pulseStretch(){
    if(!wordStretch) return;
    wordStretch.classList.remove('is-pulse');
    void wordStretch.offsetWidth;
    wordStretch.classList.add('is-pulse');
  }
  function startRotate(){
    cubeRotation += 90; /* mod しない・リセットしない（無改変） */
    cube.style.transition = 'transform ' + (ROTATE_MS/1000) + 's var(--ease-karakuri)';
    void cube.offsetWidth;
    cube.style.transform = 'rotate(' + cubeRotation + 'deg)';
    cube.addEventListener('transitionend', onRotateEnd);
    /* 2026-07-24(Y): 2号(wordSpin)も同時刻・同尺で回転（1号とは逆方向・上記chaserRotation
       コメント参照）。完了判定は1号のtransitionendのみに一本化 — 開始時刻・duration・
       easingが完全に同一のため実質同時に終わり、状態機械を2系統で待つ複雑さを避ける
       （判断報告：ズレが生じても見た目のごく僅かな誤差に留まり実害なし。2026-07-24(AA):
       この一本化方針は新順序でも無改変で踏襲 — onRotateEndが次段(跳ね返り∥めまい)の
       単一の起動トリガーであり続ける）。 */
    if(wordSpin){
      chaserRotation -= 90;
      wordSpin.style.transition = 'transform ' + (ROTATE_MS/1000) + 's var(--ease-karakuri)';
      void wordSpin.offsetWidth;
      wordSpin.style.transform = 'rotate(' + chaserRotation + 'deg)';
    }
  }
  function onRotateEnd(e){
    if(e.target !== cube || e.propertyName !== 'transform') return;
    cube.removeEventListener('transitionend', onRotateEnd);
    /* 2026-07-24(AA): 回転完了の直後に「2号の跳ね返り移動」(startBounceBack・
       BOUNCE_MS=1600ms)と「1号のめまい」(startWobble・WOBBLE_MS=500ms)を同時発火
       （新順序の後半＝併走区間）。めまいが確実に短く先に終わるため、状態機械の
       完了トリガーは跳ね返り側(onBounceEnd)のみに一本化 — めまい側(finishWobble)は
       見た目の後始末のみを担いfinishFullCourseは呼ばない（判断根拠は冒頭IIFE
       ヘッダーコメントのv8参照）。 */
    startBounceBack(); /* 「スーッ」（96pxへ後ずさる） */
    startWobble();     /* 「ふらふら」（回転の余韻として併走） */
  }
  function startBounceBack(){
    /* 2026-07-24(AA) 新設（旧startBounceの跳ね返り部分を分離し、回転完了後に発火
       するよう移動）。28px→-64px（絶対値としては接触4px→G=96へ復帰）— 発火
       タイミングは「回転の前」から「回転の後」へ変更（無改変で踏襲）。
       値・イージング構造は2026-07-24(AB)で再設計（BOUNCE_MS/BOUNCE_EASE/
       @keyframes asf-marquee-bounce-back 直上のコメント参照）。
       2026-07-24(AB) 追加: クライアント指示「伸びパルス(C)のタイミングを噴出の
       瞬間に同期させてビョーンを強調」に対応 — pulseStretch() をこの跳ね返り
       噴出の起動と同一フレームで再発火する（startImpact側の「潰れ/伸びは接触の
       瞬間」という既存の呼び出しは無改変で維持しつつ、ここでも呼ぶことで
       ストレッチ演出が実際の初速噴出の瞬間と視覚的に重なる＝二重発火だが
       是・「同じ0.4sのストレッチが噴出の合図としてもう一度光る」ことで
       「ビョーン」の衝撃を強調する狙い・判断報告） */
    pulseStretch();
    setAnim(wordApproach, (BOUNCE_MS/1000) + 's ' + BOUNCE_EASE + ' 1 forwards asf-marquee-bounce-back');
    wordApproach.addEventListener('animationend', onBounceEnd);
  }
  function onBounceEnd(e){
    if(e.target !== wordApproach || e.animationName !== 'asf-marquee-bounce-back') return;
    wordApproach.removeEventListener('animationend', onBounceEnd);
    finishFullCourse(); /* 2026-07-24(AA): 回転は既にonRotateEnd起点で完了済みのため、
       跳ね返り完了はそのままフルコース完了へ直結する（旧順序ではここからstartRotate()
       を呼んでいたが、その呼び出しはstartImpact()末尾へ移動済み）。 */
  }
  var wobbleTimer = null;
  function startWobble(){
    if(wobbleTimer) clearTimeout(wobbleTimer);
    cube.removeEventListener('animationend', onWobbleEnd);
    cube.style.setProperty('--cube-rot', cubeRotation + 'deg');
    cube.style.transition = 'none';
    void cube.offsetWidth;
    cube.classList.add('is-wobbling');
    cube.addEventListener('animationend', onWobbleEnd);
    wobbleTimer = setTimeout(finishWobble, WOBBLE_MS + 150); /* 安全網: animationend取りこぼし対策 */
  }
  function onWobbleEnd(e){
    if(e.target !== cube || e.animationName !== 'asf-cube-wobble') return;
    finishWobble();
  }
  function finishWobble(){
    /* 2026-07-24(AA): 新順序ではめまい(WOBBLE_MS=500ms)が跳ね返り(BOUNCE_MS=1600ms)
       より確実に先に終わる（回転完了を起点に同時発火・両者とも固定尺のため常に
       成立）ため、ここでは見た目の後始末（wobblingクラス解除・最終transformの
       確定）のみを行い、状態機械の完了処理(finishFullCourse)は呼ばない —
       完了トリガーはonBounceEndに一本化済み（詳細はonRotateEnd直上のコメント参照）。 */
    if(wobbleTimer){ clearTimeout(wobbleTimer); wobbleTimer = null; }
    cube.removeEventListener('animationend', onWobbleEnd);
    cube.classList.remove('is-wobbling');
    cube.style.transform = 'rotate(' + cubeRotation + 'deg)';
  }
  function finishFullCourse(){
    if(state !== 'approach') return; /* 冪等ガード */
    rung = 0; /* ラダーリセット — 衝突フルコース完了後は常に絶対値96pxへ復帰（可変ベースラインなし） */
    wordApproach.style.animation = ''; wordApproach.style.transform = '';
    renderTrack(wordTrack, cubeVX - currentGap() - wordWidth); /* currentGap()=LADDER_GAPS[0]=96 */
    finishApproachAction();
  }
  function finishApproachAction(){
    if(state !== 'approach') return; /* 冪等ガード（自然完了と安全網タイマーの競合対策） */
    state = 'rest';
    if(collisionSafetyTimer){ clearTimeout(collisionSafetyTimer); collisionSafetyTimer = null; }
    /* この時点で cubeTrack/wordTrack は cubeVX / cubeVX-currentGap()-wordWidth に
       ピン留め済み・word/cubeの局所レイヤーは既にクリア/回転蓄積値に確定済み
       — 「休憩状態」は数値的に「歩行のある瞬間を止めたスナップショット」と完全
       一致する（rungが0でなくとも、そのgap値で歩行していたのと同じ状態）。 */
    if(pendingResumeAfterApproach){
      pendingResumeAfterApproach = false;
      startWalking();
      armStill();
    } else {
      mq.classList.remove('is-frozen');
    }
  }
  function detachApproachListeners(){
    wordApproach.removeEventListener('animationend', onGraceEnd);
    wordApproach.removeEventListener('animationend', onHopEnd);
    wordApproach.removeEventListener('animationend', onBounceEnd);
    cube.removeEventListener('transitionend', onRotateEnd);
    cube.removeEventListener('animationend', onWobbleEnd);
  }
  function forceSettle(){
    /* 安全網タイマーからのみ呼ばれる。取りこぼされたイベントのリスナーを一掃した
       うえで、このアクションが「接触→衝突フルコース」狙いだったか「ソフト
       ホップ」狙いだったかに応じて、対応する完了処理へ強制的に倒す（冪等）。 */
    if(state !== 'approach') return;
    detachApproachListeners();
    if(wobbleTimer){ clearTimeout(wobbleTimer); wobbleTimer = null; }
    cube.classList.remove('is-wobbling');
    if(actionReachesContact){
      cube.style.transition = '';
      cube.style.transform = 'rotate(' + cubeRotation + 'deg)';
      finishFullCourse();
    } else {
      finishHop();
    }
  }

  /* ---- 活動検知 ---- */
  function onActivity(){
    lastActivity = Date.now();
    if(reduce && reduce.matches) return;
    if(state === 'approach'){
      /* 接近アクション中に活動が再開したケース。アクションは中断せず、完了の瞬間に
         歩行を再開するようフラグだけ立てる（1静止期間に1アクション・既存踏襲）。 */
      pendingResumeAfterApproach = true;
      return;
    }
    if(state !== 'walk') startWalking();
    armStill();
  }
  ['scroll','wheel','pointermove','pointerdown','touchstart','keydown'].forEach(function(ev){
    window.addEventListener(ev, onActivity, { passive:true });
  });

  document.addEventListener('visibilitychange', function(){
    /* タブが非表示の間 requestAnimationFrame は停止するため、復帰時に経過時間が
       一気に積算されて cubeVX が大きくジャンプするのを防ぐ — 「今の見た目の位置」
       (=最後に描画に使った cubeVX の値)を新しい基準点として再アンカーするだけで、
       DOM実測は一切不要（仮想座標アーキテクチャの利点）。 */
    if(document.hidden) return;
    if(state === 'walk'){
      walkStartVX = cubeVX;
      walkStartT = performance.now();
    }
  });
  window.addEventListener('resize', function(){
    /* renderTrack は毎回 mq.clientWidth を読むため walk 中は次フレームで自動追従。
       rest 中（rAFが回っていない）は明示的に再描画する。wordWidth もブレーク
       ポイント切替でサイズが変わりうるため再計測する。
       2026-07-24(Z): approach 中は renderRestFrame を呼ばない — approach 中の
       wordTrack は「このアクション開始時の基準ギャップ」でピン留めされており、
       wordApproach の局所ダンス値はその基準からの相対値として意味を持つ。ここで
       wordWidth が変化した新しい基準へ wordTrack を再ピンしてしまうと、進行中の
       局所ダンスの意味がズレて視覚的な不整合（ごく僅かなジャンプ）を招くリスクが
       あるため、approach 中はそのまま完走させ、次の fold (finishHop/
       finishFullCourse) 時点で自然に新しい wordWidth が反映される（measureWordWidth
       自体は毎回呼ぶため、次のアクション開始時には正しい値が使われる）。 */
    measureWordWidth();
    if(state === 'rest') renderRestFrame();
  });

  if(reduce && reduce.addEventListener){
    reduce.addEventListener('change', function(){
      if(reduce.matches){
        stopWalkingRAF();
        state = 'rest';
        rung = 0;
        pendingResumeAfterApproach = false;
        cubeRotation = 0;
        chaserRotation = 0;
        cubeVX = OFF; /* 左端定位置（可視）へ戻す — 初期化時と同じ理由でOFFが正しい基準値 */
        if(stillTimer) clearTimeout(stillTimer);
        if(collisionSafetyTimer){ clearTimeout(collisionSafetyTimer); collisionSafetyTimer = null; }
        detachApproachListeners();
        if(wobbleTimer){ clearTimeout(wobbleTimer); wobbleTimer = null; }
        cube.classList.remove('is-wobbling');
        cube.style.removeProperty('--cube-rot');
        if(cubeSquash) cubeSquash.classList.remove('is-pulse');
        if(wordStretch) wordStretch.classList.remove('is-pulse');
        wordApproach.style.animation = ''; wordApproach.style.transform = '';
        cube.style.transition = ''; cube.style.animation = ''; cube.style.transform = '';
        if(wordSpin){ wordSpin.style.transition = ''; wordSpin.style.transform = ''; }
        mq.classList.remove('is-run', 'is-frozen');
        renderRestFrame();
      }
      /* reduced-motion 解除時は何もしない — 次の実際の活動が onActivity() 経由で
         歩行開始フローへ自然に合流する（初回ロード後の挙動と同一・既存踏襲）。 */
    });
  }

  /* ---- 最終防衛ウォッチドッグ（2026-07-24(Z) 新設） ----
     上記のv7根本修正（wordApproach/spinの祖先関係入れ替え）により、通常動作では
     恒等式が破れて重なることは構造的にない。しかし「恒等式が万一破れても描画上
     は絶対に重ならない」という要求に応えるため、実際の描画位置を
     requestAnimationFrame で毎フレーム監視し、本物の重なり（同一ラップ上での
     構造ギャップ < MIN_VISUAL_GAP_WATCHDOG）を検知した場合のみ、状態機械を
     強制的に既知安全な静止状態（gap=96・ラダーリセット）へ収束させる。
     2026-07-24(Z) 実装上の注意（実測で発覚・修正済み）: 当初 getBoundingClientRect
     で cube/word の「塗り上がったピクセル境界」を直接比較していたが、衝突の瞬間
     に発火する潰れ演出(cubeSquash・scale(1.15,.85)を伴う0.1sのコスメティック
     レイヤー)が cube の見た目の箱を一時的に左右へ広げるため、意図された接触
     (CONTACT_GAP=4px)の直後にこのコスメティック効果が重なると構造的には正常
     なのに「視覚ギャップが2px未満」と誤検知し、ウォッチドッグが正常なシーケンス
     を強制中断させてしまう不具合を確認。修正: squash/stretch等の祖先レイヤーが
     持つコスメティックな scale に一切影響されない「構造座標」——各トラック
     要素自身の getComputedStyle().transform（＝そのトラック自身が持つ移動量
     そのもの・祖先の scale/rotate とは合成されない値）——のみを使ってギャップを
     再計算する方式に変更した。cube 自身は接近ダンス層を持たないため cubeTrack
     の値がそのまま cube の構造上の絶対位置、word は wordTrack + wordApproach
     の合計が絶対位置になる（wordSpin の回転は word 自身より内側の層なので
     この合計には一切影響しない — v7根本修正と同じ理屈）。
     周回テレポートで cube と word が別ラップに乗っている瞬間は構造ギャップが
     数百〜数千px の大きな負値になる（無害な既知の現象・詳細は最終報告参照）
     ため、これを本物の重なりと誤検知しないよう「構造ギャップが小さな範囲
     （-50px超）にある」ことも同時に要求する。 */
  function trackTransformX(el){
    try{ return new DOMMatrix(getComputedStyle(el).transform).m41; }catch(e){ return 0; }
  }
  function watchdogTick(){
    if(!(reduce && reduce.matches) && !document.hidden){
      var cubeX = trackTransformX(cubeTrack);
      var wordX = trackTransformX(wordTrack) + trackTransformX(wordApproach);
      var structuralGap = cubeX - (wordX + wordWidth);
      if(structuralGap > -50 && structuralGap < MIN_VISUAL_GAP_WATCHDOG){
        emergencyResolveOverlap();
      }
    }
    requestAnimationFrame(watchdogTick);
  }
  function emergencyResolveOverlap(){
    /* 通常動作では発火しない想定の最終防衛。進行中の全アニメーション/タイマーを
       破棄し、cube の現在位置はそのまま・word をその96px背後という既知安全な
       絶対位置へ直接描画し直す（測定値ではなく cubeVX からの計算値を使う —
       cubeVX 自体は仮想座標として常に正しいため、画面上の重なりの原因が
       ダンスレイヤーの描画不整合であっても cubeVX 自体は無傷なはずという前提に
       立つ最終防衛）。 */
    stopWalkingRAF();
    if(stillTimer){ clearTimeout(stillTimer); stillTimer = null; }
    if(collisionSafetyTimer){ clearTimeout(collisionSafetyTimer); collisionSafetyTimer = null; }
    detachApproachListeners();
    if(wobbleTimer){ clearTimeout(wobbleTimer); wobbleTimer = null; }
    cube.classList.remove('is-wobbling');
    cube.style.transition = ''; cube.style.animation = '';
    wordApproach.style.animation = ''; wordApproach.style.transform = '';
    if(wordSpin) wordSpin.style.transition = '';
    if(cubeSquash) cubeSquash.classList.remove('is-pulse');
    if(wordStretch) wordStretch.classList.remove('is-pulse');
    state = 'rest';
    rung = 0;
    pendingResumeAfterApproach = false;
    renderRestFrame();
    mq.classList.remove('is-run', 'is-frozen');
  }
  requestAnimationFrame(watchdogTick);

  /* ---- 初期化 ---- */
  measureWordWidth();
  renderRestFrame();
  if(!wordWidth && window.requestAnimationFrame){
    requestAnimationFrame(function(){ measureWordWidth(); renderRestFrame(); }); /* レイアウト未確定だった場合のみ次フレームで補正 */
  }
  /* 初期状態は静止のまま — 最初の実活動が onActivity() 経由で歩行を起動するまで、
     キューブは左端定位置・ASFは画面外待機で何も起こらない（既存踏襲）。 */
})();
});

/* ==== [02] 原本 sections/asf-index.liquid L2303-2347 ==== */
/* ============================================================
   HEADER スクロール状態 + .reveal の IntersectionObserver
   出典: demo-v3 index.html（フッター直後の IIFE）をそのまま移送。

   theme-v3 での変更点:
     ① asfBoot() で包む（§(h) h-5）。.reveal も .site-header も content_for_layout の中
        ＝このスクリプトより前に DOM がある保証が無いため。
     ② デモの A.S.F. List 送信ハンドラは <head> の GA 共通ブロックへ集約済みで元々ここには無い。
        theme-v3 では実 POST（Batch 6）まで「送信で実ナビゲーションさせない」ガードを別 IIFE で持つ。
============================================================ */
window.asfBoot(function(){
  'use strict';
  if (window.__asfBootIndexChrome) return;   /* シングルトン・ガード */
  window.__asfBootIndexChrome = true;

  var header = document.getElementById('site-header');

  /* ---------- Header scroll state ---------- */
  if(header){
    var onScroll = function(){
      if(window.scrollY > 8){ header.classList.add('is-scrolled'); }
      else{ header.classList.remove('is-scrolled'); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive:true });
  }

  /* ---------- Reveal on scroll → 【2026-07-30 全面無効化】即時表示 ----------
     クライアント指示（原文引用）: 「スマホ版もPC版も、スクロールすると下のコンテンツが徐々に表示されていく UI が
     ちょっとうざいので、最初からなるべく表示されているように変更して」。
     採った形（最小・確実）: IntersectionObserver を**生成しない**。DOM 準備直後に全 .reveal へ .in-view を
     1回付与するだけ（旧・IO 非対応ブラウザ向けフォールバックと完全同一の経路）。
     ★ .in-view を付け続ける理由 ★ CSS 側（assets/asf-theme.css L687 付近）は .reveal(0,1,0) と
       .reveal.in-view(0,2,0) の二段構造で、後者が「出現後の最終値」を持つ。無効化に際して CSS は両方を
       表示値へ揃えたが、.in-view が付いた状態こそが従来の最終状態と 1:1 で同じカスケード（他ブロックの
       opacity 規則との勝敗関係も同じ）になるため、クラス付与自体は温存する＝**見た目は「出現し終わった
       ページ」と完全同一・タイミングだけ 0 フレーム**。
     ★ 対象外（維持）★ LOOK カウンター/ナビ矢印の idle フェード・カルーセル自動回転の可視制御（vio）・
       SHOP 背景動画の遅延 fetch（bgIO）・LOOK stage の IO・PLAYER BOX 音源アーム（armOnVisible）は
       スクロール出現とは別機構のため一切触っていない。
     ★ 復帰点 ★ 下のコメント内に旧 IO ブロックを保存。CSS 側 .reveal を opacity:0/translateY(18px) に戻し、
       この関数を旧コードへ差し替えれば元の挙動に戻る。
       旧コード:
         if('IntersectionObserver' in window){
           var io = new IntersectionObserver(function(entries){
             entries.forEach(function(entry){
               if(entry.isIntersecting){ entry.target.classList.add('in-view'); io.unobserve(entry.target); }
             });
           }, { threshold:0.12, rootMargin:'0px 0px -8% 0px' });
           revealEls.forEach(function(el){ io.observe(el); });
         } else { revealEls.forEach(function(el){ el.classList.add('in-view'); }); }
  */
  var revealEls = document.querySelectorAll('.reveal');
  revealEls.forEach(function(el){ el.classList.add('in-view'); });
});

/* ==== [03] 原本 sections/asf-index.liquid L2350-2820 ==== */
/*
  [theme-v3 / Batch 1] TRESOR カルーセル・ファクトリ + 共有ライトボックス（window.asfViewer）
  出典: demo-v3 index.html の同名 IIFE を **逐語移送**（ロジック無改変）。
  theme-v3 での唯一の変更は次の2点だけ:
    (1) window.asfBoot(...) で包む — このセクションは content_for_layout の中で描画され、
        demo のように </body> 直前で DOM が揃っている保証が無いため（§(h) h-5）。
    (2) window.__asfBootCarousel のシングルトン・ガード（二重マウント事故の構造的排除）。
  #lookLightbox / #lookCarousel は本セクションが描画する（どちらも 〈main〉 の外・fixed）。
  画像 URL は JS に直書きせずマークアップの data-thumb / data-large（Liquid 由来）から読む＝無改変で成立。
*/
window.asfBoot(function(){
  if (window.__asfBootCarousel) return;
  window.__asfBootCarousel = true;

/* ============================================================
   TRESOR CAROUSEL 共通ファクトリ — ヒーロー（2枚）+ LOOK（35枚）の2インスタンス
   採用値（tresorberlin.com 実測 = Splide v2.4.20 実コード抽出）:
   - 自動回転間隔 INTERVAL = 3600ms（scripts.js の明示指定）
   - 遷移 SPEED = 400ms / EASING = cubic-bezier(.42,.65,.27,.99)（v2 既定値）
   - pauseOnHover: true / pauseOnFocus: false
   - 手動操作（ドラッグ）終了で即時再開 — 次送りは INTERVAL 後
   - lazyLoad 'nearby'（±2 thumb 先読み・現在スライド large 昇格）
   - type 'loop'（前後クローン）/ reduced-motion: 自動回転なし・遷移即時
   - 矢印ボタンなし（クライアント指示）— 手動送りはスワイプ/ドラッグ + キーボード ←→
   - 画面外は自動回転停止（IntersectionObserver — 2カルーセル並走のパフォーマンス配慮）
   タップ（移動量 < 10px）で共有ライトボックス（ピンチズーム + サイズ左下表示）
============================================================ */
(function(){
  'use strict';
  var INTERVAL = 3600;
  var SPEED = 400;
  var EASING = 'cubic-bezier(.42,.65,.27,.99)';
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function motionOff(){ return !!(reduceMotion && reduceMotion.matches); }
  function pad2(n){ return (n < 10 ? '0' : '') + n; }

  /* ---------- 共有ライトボックス（従来のピンチズーム実装を entries 引数化） ---------- */
  var viewer = (function(){
    var lightbox = document.getElementById('lookLightbox');
    var lbImg = document.getElementById('lookLightboxImg');
    var lbCounter = document.getElementById('lookLightboxCounter');
    var lbSize = document.getElementById('lookLightboxSize');
    var lbCloseBtn = document.getElementById('lookLightboxClose');
    /* 2026-07-21(18): 前後矢印ボタンは撤去 — 参照・ガード・リスナーとも掃除（前後移動はスワイプ / ←→ が継続）
       2026-07-29 クライアント指示で復活（別実装）: 拡大表示に前後送りの矢印を追加する。
       ・実装場所は**共有ビューアのここ1箇所**だけ＝ PHOTO(01/18) / LOOK / ARCHIVE フライヤー /
         オーバーレイ経路の商品 LOOK(02/02) など、entries を渡す全コンテキストへ自動的に効く。
       ・表示は「複数枚のときだけ」— lbRender で .is-multi を付け外し、実際の可視化は CSS 側
         （PC 限定・.is-cycle 除外）が担う（意匠・条件の単一の持ち主は CSS・§ハウス規約）。
       ・挙動はキーボード ←→ と**同じ関数**（step）を共有＝送り方向・端の巻き戻し・カウンター更新が
         必ず一致する（別経路で実装しない）。
       ・要素が無いテンプレート（商品直リンクの最小ライトボックス等）でも null 安全に no-op。 */
    var lbPrevBtn = document.getElementById('lookLightboxPrev');
    var lbNextBtn = document.getElementById('lookLightboxNext');
    if(!lightbox || !lbImg || !lbCloseBtn) return null;

    var entries = [], lbIdx = 0, lbOpenFlag = false, onCloseCb = null;
    var cycleMode = false; /* WOMB 表裏 2026-07-21(4): タップで 表 → 裏 → 閉 と進むモード */

    function lbRender(){
      if(lbIdx < 0) lbIdx = entries.length - 1;
      if(lbIdx >= entries.length) lbIdx = 0;
      var en = entries[lbIdx];
      /* [theme-v3] #lookLightboxImg のプレースホルダ width/height を実画像割当の直前に外す
         （理由は本セクションの #lookLightbox マークアップ側コメント参照）。 */
      lbImg.removeAttribute('width'); lbImg.removeAttribute('height');
      lbImg.src = en.full;
      lbImg.alt = en.alt;
      lbCounter.textContent = pad2(lbIdx + 1) + ' / ' + pad2(entries.length);
      /* 2026-07-29: 「複数枚のギャラリーのときだけ矢印」— 実際の表示可否（PC 限定 / .is-cycle 除外）は
         CSS が持つ。ここは条件のフラグを立てるだけ＝カウンター（01 / 18）と同じ真実源から導出。 */
      lightbox.classList.toggle('is-multi', entries.length > 1);
      if(lbSize){
        lbSize.textContent = en.size;
        lbSize.hidden = !en.size;
      }
      zoomReset(false);
    }
    function open(list, i, onClose, opts){
      entries = list; lbIdx = i; onCloseCb = onClose || null;
      cycleMode = !!(opts && opts.tapCycle);
      lightbox.classList.toggle('is-cycle', cycleMode);
      lightbox.classList.toggle('is-light', !!(opts && opts.theme === 'light')); /* 2026-07-21(16): VISUAL 起点 = 白テーマ */
      lbOpenFlag = true;
      lbRender();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('look-lightbox-open');
      lbCloseBtn.focus();
    }
    function close(){
      if(!lbOpenFlag) return;
      lbOpenFlag = false;
      cycleMode = false;
      lightbox.classList.remove('is-cycle');
      lightbox.classList.remove('is-light'); /* 2026-07-21(16): テーマは開くたびに起点側が指定 */
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('look-lightbox-open');
      zoomReset(false);
      if(onCloseCb) onCloseCb();
    }

    /* 2026-07-29: 前後送りの唯一の実装。キーボード ←→ もこの step を呼ぶ（挙動の二重定義を避ける）。
       lbRender が lbIdx を 0..length-1 に丸めるので端の巻き戻しは従来どおり。 */
    function step(delta){
      if(entries.length < 2) return;
      lbIdx += delta;
      lbRender();
    }
    if(lbPrevBtn) lbPrevBtn.addEventListener('click', function(e){ e.stopPropagation(); step(-1); });
    if(lbNextBtn) lbNextBtn.addEventListener('click', function(e){ e.stopPropagation(); step(1); });

    lbCloseBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function(e){
      if(zScale > 1.01) return;
      if(e.target.closest && e.target.closest('.look-lightbox__close')) return;
      /* 2026-07-29: 矢印クリックは背景クリック（閉じる）にも tapCycle（次面へ進む）にも落とさない。
         上のボタン側 stopPropagation との二重防御（委譲経路が増えても安全側に倒す）。 */
      if(e.target.closest && e.target.closest('.look-lightbox__nav')) return;
      /* tapCycle（WOMB 表裏 2026-07-21(4)）: 画像/背景どこをタップしても 次の面 → 最終面の次で閉。
         × / ESC は下の既存ハンドラで常時閉 */
      if(cycleMode){
        if(lbIdx < entries.length - 1){ lbIdx++; lbRender(); }
        else { close(); }
        return;
      }
      if(e.target === lightbox || e.target.classList.contains('look-lightbox__stage')) close();
    });
    document.addEventListener('keydown', function(e){
      if(!lbOpenFlag) return;
      if(e.key === 'Escape') close();
      else if(e.key === 'ArrowLeft'){ step(-1); }   /* 2026-07-29: 矢印ボタンと同一関数（挙動一致の保証） */
      else if(e.key === 'ArrowRight'){ step(1); }
    });

    /* ---- pinch-zoom / pan / double-tap ---- */
    var ZOOM_MIN = 1, ZOOM_MAX = 4;
    var zScale = 1, zPanX = 0, zPanY = 0;
    var pinchActive = false, pinchStartDist = 0, pinchStartScale = 1, pinchStartPanX = 0, pinchStartPanY = 0;
    var panActive = false, panStartX = 0, panStartY = 0, panOriginX = 0, panOriginY = 0;
    var lastTapTime = 0, lastTapX = 0, lastTapY = 0;

    function touchDist(t0, t1){
      var dx = t1.clientX - t0.clientX, dy = t1.clientY - t0.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function clampPan(){
      var w = lbImg.offsetWidth, h = lbImg.offsetHeight;
      var maxX = Math.max(0, (w * zScale - w) / 2);
      var maxY = Math.max(0, (h * zScale - h) / 2);
      zPanX = Math.max(-maxX, Math.min(maxX, zPanX));
      zPanY = Math.max(-maxY, Math.min(maxY, zPanY));
    }
    function applyZoomTransform(){
      lbImg.style.transform = 'translate(' + zPanX + 'px,' + zPanY + 'px) scale(' + zScale + ')';
    }
    function zoomSet(scale, panX, panY, animate){
      zScale = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, scale));
      zPanX = panX; zPanY = panY;
      clampPan();
      if(animate){
        lbImg.style.transition = 'transform .25s cubic-bezier(.22,.61,.36,1)';
        applyZoomTransform();
        setTimeout(function(){ lbImg.style.transition = ''; }, 260);
      } else {
        lbImg.style.transition = '';
        applyZoomTransform();
      }
    }
    function zoomReset(animate){
      pinchActive = false; panActive = false;
      zoomSet(1, 0, 0, animate);
    }

    var lbTX = null, lbDx = 0;
    lightbox.addEventListener('touchstart', function(e){
      if(e.target.closest && e.target.closest('.look-lightbox__close')) return;
      if(e.touches.length === 2){
        pinchActive = true; panActive = false; lbTX = null; lbDx = 0;
        pinchStartDist = touchDist(e.touches[0], e.touches[1]);
        pinchStartScale = zScale;
        pinchStartPanX = zPanX; pinchStartPanY = zPanY;
        return;
      }
      var t = e.touches[0]; if(!t) return;
      var now = Date.now();
      if(now - lastTapTime < 300 && Math.abs(t.clientX - lastTapX) < 30 && Math.abs(t.clientY - lastTapY) < 30){
        lastTapTime = 0;
        zoomSet(zScale > 1.01 ? 1 : 2, 0, 0, true);
        lbTX = null; panActive = false;
        return;
      }
      lastTapTime = now; lastTapX = t.clientX; lastTapY = t.clientY;
      if(zScale > 1.01){
        panActive = true;
        panStartX = t.clientX; panStartY = t.clientY;
        panOriginX = zPanX; panOriginY = zPanY;
      } else {
        lbTX = t.clientX; lbDx = 0;
      }
    }, { passive:true });

    lightbox.addEventListener('touchmove', function(e){
      if(pinchActive && e.touches.length === 2){
        var d = touchDist(e.touches[0], e.touches[1]);
        var scale = pinchStartScale * (d / Math.max(1, pinchStartDist));
        zoomSet(scale, pinchStartPanX, pinchStartPanY, false);
        return;
      }
      if(panActive){
        var t = e.touches[0]; if(!t) return;
        zoomSet(zScale, panOriginX + (t.clientX - panStartX), panOriginY + (t.clientY - panStartY), false);
        return;
      }
      var t2 = e.touches[0]; if(!t2 || lbTX === null) return;
      lbDx = t2.clientX - lbTX;
    }, { passive:true });

    lightbox.addEventListener('touchend', function(e){
      if(pinchActive){
        if(e.touches.length < 2){
          pinchActive = false;
          if(zScale <= 1.01) zoomSet(1, 0, 0, true);
        }
        return;
      }
      if(panActive){
        if(e.touches.length === 0) panActive = false;
        return;
      }
      if(lbTX === null) return;
      var dx = lbDx; lbTX = null; lbDx = 0;
      if(Math.abs(dx) > 40){ lbIdx += (dx < 0 ? 1 : -1); lbRender(); }
    });

    return {
      open: open,
      isOpen: function(){ return lbOpenFlag; }
    };
  })();
  window.asfViewer = viewer; /* BRIEF10: VINYL ジャケット拡大 / PHOTO グリッドから共有ライトボックスを利用 */

  /* ---------- カルーセル・ファクトリ ---------- */
  /* 第4引数 creditsId は 2026-07-30 のゲート撤去で廃止（下の経緯コメント参照）。呼び出し側も追随済み */
  function initCarousel(rootId, trackId, counterId){
    var carousel = document.getElementById(rootId);
    var track = document.getElementById(trackId);
    var counterEl = document.getElementById(counterId);
    if(!carousel || !track || !counterEl) return;
    var slides = Array.prototype.slice.call(track.children);
    var N = slides.length;
    if(N < 2) return;

    /* ========================================================================
       2026-07-30 クライアント指示（**明示的なリセット**）: クレジットの「◯枚見たら出現」ゲートを
       全面撤去。ここにあった markSeen / seen / seenCount / allSeenDone / CREDIT_THRESHOLD と
       creditsEl（.is-look-seen を付与する側）を削除し、initCarousel の第4引数 creditsId も廃止した。

       ★ 経緯（将来の読み手へ・重要 — 事故で消えたのではない）★
         2026-07-22(7) 全9枚視聴で出現 → 2026-07-27 しきい値3枚へ緩和（**ゲートは意図的に維持**と裁定）
         → 2026-07-30 クライアントが「読み込んだ瞬間から見えていてほしい」へ方針転換。
         直前のバッチで「3枚ゲートは残す」と明確に決めた経緯があるため、この削除が
         **意図的なものである**ことをここに明記する。復活させないこと。
       ★ 対になる CSS 側の撤去 ★ assets/asf-theme.css の
         .look-credits{opacity:0;pointer-events:none} / .look-credits.is-look-seen{…} の 2 宣言と、
         写真番号の没入消灯（body.is-visual-idle .look-counter）も同時に撤去済み。
         詳細な経緯はあちらのコメントに集約してある。
       ★ 非対象 ★ PC 送り矢印（.look-nav）の消灯挙動は現状維持。
       ======================================================================== */

    var pos = 0, animating = false;

    /* ========================================================================
       look_photo_view — LOOKS “OUT OF CLUB” 写真の閲覧計測（2026-07-31 クライアント指示）
       原文要旨:「VISUAL の OUT OF CLUB の写真をどれだけの人が見てくれているのか分からない」。
       ────────────────────────────────────────────────────────────────────────
       ★ 仕様 ★
         イベント名 : look_photo_view
         パラメータ : photo_number = '01'〜'11'（カルーセルの表示順・DOM 順の自動採番。
                                                写真番号カウンター #lookCarouselCounter と同じ値）
                      collection   = 'OUT OF CLUB'（キャプセル名。将来別コレクションを載せた時の識別子）
         発火条件   : ①スライドが切り替わったとき（自動回転・矢印・ドラッグ・クリック送り・キーボード
                        ←→ のすべて。goTo() が唯一の遷移点なのでそこ 1 箇所で足りる）
                      ②VISUAL ビューが表示になったときの現在スライド（IntersectionObserver で検出）
         抑制       : 直前に送った番号と同じなら送らない（連続重複の抑制）。
         非発火     : VISUAL ビューが非表示の間（#visual に .is-active が無い）。
                      商品 / bio オーバーレイが上に載っている間（下のビューは活きているが
                      ユーザーは写真を見ていないため）。
       ★ なぜ IntersectionObserver を「表示」の検出に使うのか ★
         非アクティブなビューは .view{display:none} なのでカルーセルはボックスを持たず、IO は
         必ず isIntersecting:false を返す。つまり IO の true 化は「写真が実際に画面へ出た」と同義で、
         ルーターの内部状態に依存しない（＝ハッシュ直着地・タブ切替・フリック送りのどの経路でも
         同じ 1 箇所で拾える）。IO 非対応環境の保険として hashchange でも同じ関数を叩く。
       ★ 送信経路 ★ window.asfTrack（layout の gtag('event') ラッパ）のみ。gtag は直接呼ばない
         （gtag('config') は layout の 1 箇所という既存契約を侵さないため）。
       ★ スコープ ★ initCarousel の呼び出しは LOOK ステージ 1 箇所だけだが、将来 2 本目の
         カルーセルが載っても巻き込まないよう rootId で明示ガードする。
       ======================================================================== */
    var GA_LOOK = (rootId === 'lookCarousel');
    var GA_COLLECTION = 'OUT OF CLUB';
    var gaLastPhoto = null;
    function gaVisualVisible(){
      var v = document.getElementById('visual');
      if(!v || !v.classList.contains('is-active')) return false;
      /* オーバーレイ表示中は写真が見えていない（body クラスは各オーバーレイ IIFE が持つ既存の印） */
      var b = document.body;
      if(b.classList.contains('product-overlay-open') || b.classList.contains('bio-overlay-open')) return false;
      return true;
    }
    function trackPhotoView(i){
      if(!GA_LOOK || !gaVisualVisible()) return;
      var n = pad2(mod(i) + 1);
      if(n === gaLastPhoto) return;      /* 連続重複の抑制 */
      gaLastPhoto = n;
      try{
        if(typeof window.asfTrack === 'function'){
          window.asfTrack('look_photo_view', { photo_number: n, collection: GA_COLLECTION });
        }
      }catch(e){}
    }
    var dragging = false, dragStartX = 0, dragStartT = 0, dragDx = 0, lastDragAbs = 0, dragPointerId = null;
    var hovering = false, timer = null;
    var inView = true;

    /* 2026-07-21(11) クライアント指示: 隣接スライドの端の写り込み（クリッピング不良）根治 —
       ステージ幅が svh calc 由来の小数 px（例 633.594px @1280）だと、静止時でもスライド境界が
       デバイスピクセル格子に乗らず、コンポジタの再標本化で左右端に隣スライドが約1px滲む
       （実測: 右端に次スライドの赤が縦線状に出る）。ステージ幅を整数 px にスナップし、さらに
       センタリング由来の小数 left も打ち消して translateX(±k×100%) を常に整数格子に載せる。
       ビュー非表示中（rect 幅 0）はスナップせず、表示時（hashchange 後）に再実行 */
    function snapGeometry(){
      carousel.style.width = '';
      carousel.style.left = '';
      var r = carousel.getBoundingClientRect();
      if(r.width < 10){ return; } /* ビュー display:none 中 — 素の CSS のまま次回へ */
      carousel.style.width = Math.round(r.width) + 'px';
      var r2 = carousel.getBoundingClientRect();
      var frac = r2.left - Math.round(r2.left);
      if(frac !== 0){ carousel.style.left = (-frac) + 'px'; } /* .np-carousel は position:relative 既定 */
    }
    snapGeometry();
    setTimeout(snapGeometry, 0); /* 直リンク #visual 読込時: ルーター（後続 script・hashchange 非発火）の初期ビュー活性化後に再実行 */
    window.addEventListener('load', snapGeometry); /* レイアウト確定後の保険 */
    window.addEventListener('resize', snapGeometry);
    window.addEventListener('hashchange', function(){
      setTimeout(snapGeometry, 0); /* ルーターのビュー切替後に実行 */
      /* 2026-07-31: IntersectionObserver 非対応環境での look_photo_view の保険。
         対応環境では IO 側が先に同じ番号を送っているので、連続重複の抑制で二重送信にはならない。 */
      setTimeout(function(){ trackPhotoView(pos); }, 0);
    });

    /* ---- 遅延読込（nearby）---- */
    function loadThumb(slide){
      var img = slide.querySelector('img');
      if(!img || img.getAttribute('src')) return;
      var t = img.getAttribute('data-thumb');
      if(t){ img.src = t; img.removeAttribute('data-thumb'); }
    }
    function upgradeLarge(slide){
      var img = slide.querySelector('img');
      if(!img) return;
      loadThumb(slide);
      var l = img.getAttribute('data-large');
      if(!l) return;
      var pre = new Image();
      pre.onload = function(){ img.src = l; };
      pre.src = l;
      img.removeAttribute('data-large');
    }
    function mod(i){ return ((i % N) + N) % N; }
    function ensureNearby(i){
      for(var d = -2; d <= 2; d++){ loadThumb(slides[mod(i + d)]); }
      upgradeLarge(slides[mod(i)]);
    }

    /* ---- ループ用クローン ---- */
    var cloneLast = slides[N - 1].cloneNode(true);
    var cloneFirst = slides[0].cloneNode(true);
    [cloneLast, cloneFirst].forEach(function(c){
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      c.removeAttribute('role');
    });
    track.insertBefore(cloneLast, slides[0]);
    track.appendChild(cloneFirst);

    function xFor(i){ return -(i + 1) * 100; }
    function setX(i, withTransition){
      var speed = motionOff() ? 0 : SPEED;
      track.style.transition = (withTransition && speed) ? ('transform ' + speed + 'ms ' + EASING) : 'none';
      track.style.transform = 'translateX(' + xFor(i) + '%)';
    }
    function syncClones(){
      var f = slides[0].querySelector('img'), fc = cloneFirst.querySelector('img');
      var l = slides[N - 1].querySelector('img'), lc = cloneLast.querySelector('img');
      if(f && fc && f.getAttribute('src') && fc.getAttribute('src') !== f.getAttribute('src')) fc.src = f.getAttribute('src');
      if(l && lc && l.getAttribute('src') && lc.getAttribute('src') !== l.getAttribute('src')) lc.src = l.getAttribute('src');
    }
    /* 2026-07-29 クライアント指示: LOOK の写真番号は分数（01 / 09）をやめ**現在番号のみ**（01, 02, …）。
       ★ スコープ ★ initCarousel の唯一の呼び出しは L1332 の LOOK ステージ 1 箇所なので、この行の変更は
         LOOK 以外に波及しない。PHOTO ライトボックスのカウンター（01 / 18・L908 の lbCounter）は
         **意図的に非改変** — 18 枚のギャラリーでは「あと何枚あるか」の情報価値が実際にあるため、
         同じ見た目だからと巻き込みで変えない（変更要否はクライアント確認事項・完了報告に記載）。
       ★ 初期値 ★ 初回ペイントで旧書式が一瞬出る（FOUC）のを避けるため、snippets/asf-tab-visual.liquid
         側の初期テキストも同時に「01」へ変更済み。N は下の pad2(N) 参照が消えても
         スライド枚数として他所で使われ続けるので未使用にはならない。 */
    function updateCounter(){ counterEl.textContent = pad2(pos + 1); }

    /* 2026-07-23 クライアント指示: 「PCのぞき見レイヤー」機能（2026-07-22(25)(26)で追加した
       peekPrevImg/peekNextImg/peekSrcFor/updatePeekGeometry/updatePeek 一式・resize リスナー・
       goTo() 内の呼び出し）を全面撤去済み。導入前の状態に復帰 — 縦位置写真の左右は contain の
       単純な余白（背景色のみ）に戻る。矢印・スナップ・自動回転・没入モード・クレジット表示条件・
       ライトボックス等の送り機構本体はこの撤去と無関係のため無傷（詳細は<head>内CSS側コメント・
       HTML側コメント参照） */

    function goTo(i, dir){
      if(animating) return;
      var visual;
      if(dir === 1 && i === 0 && pos === N - 1) visual = N;
      else if(dir === -1 && i === N - 1 && pos === 0) visual = -1;
      else visual = i;
      animating = true;
      ensureNearby(i);
      syncClones();
      var speed = motionOff() ? 0 : SPEED;
      track.style.transition = speed ? ('transform ' + speed + 'ms ' + EASING) : 'none';
      track.style.transform = 'translateX(' + xFor(visual) + '%)';
      pos = i;
      updateCounter();
      trackPhotoView(i);   /* 2026-07-31: look_photo_view（唯一の遷移点なのでここ 1 行で全操作を捕捉） */
      /* 2026-07-30: ここにあった markSeen(i)（クレジット出現ゲートの計測）は撤去。上の経緯コメント参照 */
      var done = function(){
        animating = false;
        setX(i, false); /* 2026-07-21(11): ラップ時以外も常に最終位置を transition なしで再確定 —
           タブ非表示化等で CSS トランジションが凍結すると中間位置（隣スライドの端が見える状態）の
           まま固まるため、静止状態は毎回・非トランジションの正値で上書きして根治 */
      };
      if(speed){ setTimeout(done, speed + 20); } else { done(); }
    }
    function next(){ goTo(mod(pos + 1), 1); }
    function prev(){ goTo(mod(pos - 1), -1); }

    /* ---- 自動回転（画面外・非表示タブ・hover・ドラッグ・ライトボックス中は停止）---- */
    /* 2026-08-05 世代 -35 LOOKS 全画面ビューワー: 最終行の 1 条件のみ追加（1 行の改変）。
       ★ 追加しないと、ビューワーで画面を覆っている間も背後のカルーセルが 3.6s ごとに
         自動回転し、**誰も見ていない写真の look_photo_view が飛び続ける**（GA の意味論が壊れる）★
       共有ビューア（asfViewer）に対する既存ガード `!(viewer && viewer.isOpen())` と同型で、
       本ビューワーは自前 DOM を JS で作る独立ファイルなので body の class を印として使う。
       ★ 既定 / neuedin では恒偽 ★ look-viewer-open は soehne モードでしか付かないので
         autoplayAllowed() の戻り値は 1 度も変わらない（完全に不活性）。 */
    function autoplayAllowed(){
      return !motionOff() && !document.hidden && inView && !hovering && !dragging &&
             !(viewer && viewer.isOpen()) &&
             !document.body.classList.contains('look-viewer-open');
    }
    function stopTimer(){ if(timer){ clearTimeout(timer); timer = null; } }
    function schedule(){
      stopTimer();
      timer = setTimeout(function(){
        if(autoplayAllowed()){ next(); }
        schedule();
      }, INTERVAL);
    }

    carousel.addEventListener('mouseenter', function(){ hovering = true; });
    carousel.addEventListener('mouseleave', function(){ hovering = false; schedule(); });
    document.addEventListener('visibilitychange', function(){
      if(!document.hidden){ setX(pos, false); schedule(); } /* 2026-07-21(11): タブ復帰時、凍結していた中間トランジションを現在位置へ即時確定してから自動回転を再開 */
    });
    if('IntersectionObserver' in window){
      inView = false;
      var vio = new IntersectionObserver(function(es){
        es.forEach(function(en){ inView = en.isIntersecting; });
        if(inView){ schedule(); trackPhotoView(pos); }   /* 2026-07-31: VISUAL 進入時の初期スライドを計測（上のブロック②） */
      }, { threshold: 0.15 });
      vio.observe(carousel);
    }

    /* ---- ドラッグ / スワイプ ---- */
    carousel.addEventListener('pointerdown', function(e){
      if(animating) return;
      dragging = true; dragDx = 0; lastDragAbs = 0;
      dragStartX = e.clientX; dragStartT = Date.now();
      dragPointerId = e.pointerId;
      track.style.transition = 'none';
      stopTimer();
    });
    window.addEventListener('pointermove', function(e){
      if(!dragging || e.pointerId !== dragPointerId) return;
      dragDx = e.clientX - dragStartX;
      track.style.transform = 'translateX(calc(' + xFor(pos) + '% + ' + dragDx + 'px))';
    });
    function endDrag(e){
      if(!dragging) return;
      if(e && e.pointerId !== undefined && e.pointerId !== dragPointerId) return;
      dragging = false;
      lastDragAbs = Math.abs(dragDx);
      var dt = Math.max(1, Date.now() - dragStartT);
      var velocity = lastDragAbs / dt;
      var w = carousel.offsetWidth || 1;
      if(lastDragAbs > w * 0.2 || (lastDragAbs > 24 && velocity > 0.3)){
        if(dragDx < 0){ next(); } else { prev(); }
      } else if(lastDragAbs > 0){
        setX(pos, true);
      }
      dragDx = 0;
      setTimeout(function(){ lastDragAbs = 0; }, 80);
      schedule(); /* dragend で即時再開（Tresor 実測挙動） */
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    /* ---- キーボード ←→（矢印ボタン撤去の代替・視覚要素なし）---- */
    carousel.addEventListener('keydown', function(e){
      if(viewer && viewer.isOpen()) return;
      if(e.key === 'ArrowLeft'){ e.preventDefault(); prev(); schedule(); }
      else if(e.key === 'ArrowRight'){ e.preventDefault(); next(); schedule(); }
    });

    /* ---- 2026-07-21(18): PC 専用・カルーセル下（クレジット帯）の小さな前後矢印 ----
       既存 prev/next を流用。自動回転との整合はキーボード ←→ と同一
       （操作後 schedule() で INTERVAL 再アーム）。要素はモバイルでは CSS 非表示 */
    var navPrev = document.getElementById('lookNavPrev');
    var navNext = document.getElementById('lookNavNext');
    if(navPrev){ navPrev.addEventListener('click', function(){ prev(); schedule(); }); }
    if(navNext){ navNext.addEventListener('click', function(){ next(); schedule(); }); }

    /* ---- 2026-07-26 クライアント指示「①写真クリック/タップ→ライトボックスを PC/SP とも撤去 ②PC:写真クリック=次へ送り
       ／SP はフリックのみ・タップ無反応」への対応（旧: タップ→共有ライトボックス viewer.open(entries...)・Enter/Space も同様）----
       撤去したのは「LOOK スライドからライトボックスを開く経路」のみ。共有ビューア（window.asfViewer / .look-lightbox の
       DOM/CSS/JS）自体は VINYL ジャケット拡大・PHOTO グリッド・フライヤーストリップ・次パーティ静止画が依存しているため
       削除せず温存する（.look-lightbox 全体を dead 化するとそれらが回帰するため — タスク指示の「.look-lightbox 資産は
       dead 化」は LOOK からの呼び出し経路に限定して適用・判断報告）。
       新挙動: PC(hover:hover かつ pointer:fine)=クリックで次送り／SP(coarse)=タップ無反応（フリック送りは下の
       pointerdown/move/up ハンドラが従来どおり担当）。ドラッグ終端のクリックは既存 lastDragAbs ガードで無視。
       キーボード ←→ は既存 carousel keydown ハンドラが継続担当（Enter/Space での拡大は撤去に伴い廃止）。
       data-full/data-size 属性は旧ライトボックス用の inert データとしてマークアップに残置（未参照・無害） */
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    function bindAdvance(el){
      el.addEventListener('click', function(){
        if(lastDragAbs > 10){ lastDragAbs = 0; return; } /* スワイプ終端のクリックは無視（既存ガード踏襲） */
        if(finePointer && finePointer.matches){ next(); schedule(); } /* PC=次送り（キーボード ←→ / SP フリックと同じく操作後 schedule 再アーム）。SP(coarse)は無反応 */
      });
    }
    slides.forEach(function(sl){ bindAdvance(sl); });
    bindAdvance(cloneFirst);
    bindAdvance(cloneLast);

    /* ---- 初期化 ---- */
    ensureNearby(0);
    syncClones();
    setX(0, false);
    updateCounter();
    /* 2026-07-30: ここにあった markSeen(0)（初期スライドの既視計上）は撤去。上の経緯コメント参照 */
    /* 2026-07-31: #visual へ直着地したときの 1 枚目。IO が同じ検出をするので通常は重複抑制で握り潰されるが、
       ルーターの活性化と IO の初回コールバックの順序に依存しないよう明示的に 1 回叩いておく。 */
    trackPhotoView(0);
    schedule();
  }

  /* ヒーローはクライアント指示で1枚固定化 — initCarousel は LOOK のみ */
  initCarousel('lookCarousel', 'lookCarouselTrack', 'lookCarouselCounter'); /* 2026-07-30: 第4引数 'lookCredits'（出現ゲート）は廃止 */
})();
});

/* ==== [04] 原本 sections/asf-index.liquid L2823-2903 ==== */
/*
  [theme-v3 / Batch 1] FLICK VIEW NAV（横フリックで隣のビューへ）
  出典: demo-v3 index.html の同名 IIFE を **逐語移送**（ロジック無改変）。
  theme-v3 での唯一の変更は次の2点だけ:
    (1) window.asfBoot(...) で包む — このセクションは content_for_layout の中で描画され、
        demo のように </body> 直前で DOM が揃っている保証が無いため（§(h) h-5）。
    (2) window.__asfBootFlickNav のシングルトン・ガード（二重マウント事故の構造的排除）。
  切替は location.hash 代入＝既存ハッシュルーター（snippets/asf-overlay-host.liquid）経由。
*/
window.asfBoot(function(){
  if (window.__asfBootFlickNav) return;
  window.__asfBootFlickNav = true;

/* ============================================================
   FLICK VIEW NAV — 2026-07-21(17) クライアント指示: 横フリックで隣のビューへ
   CLUB ⇄ LABEL ⇄ VISUAL ⇄ SHOP ⇄ CHART（順序どおり・端で停止・ラップなし。
   2026-07-22(25) クライアント指示でタブ順を CLUB/CHART/VISUAL/SHOP/LABEL → 上記の新順序へ変更・
   本配列もタブ順と同期して更新）。
   切替は既存 hash ルーター経由（location.hash 代入 → タブ点灯・履歴・スクロール復帰とも既存挙動）。
   誤発火防止:
   - 除外リスト（closest 相当の祖先走査）: LOOK カルーセル #lookCarousel / ARCHIVE フライヤー
     ストリップ .flyer-strip / SC プレイヤー .sc-player（シークバー含む）/ ライトボックス
     .look-lightbox / ビデオモーダル .video-modal / クイックナビパネル .quicknav__panel /
     [role="slider"] — いずれも自前の横ジェスチャ/オーバーレイを持つため対象外
   - 保険: リスト外でも祖先に「横スクロール実容量のある overflow-x:auto|scroll」があれば対象外
     （将来の横スクロール要素追加に自動追従）
   - 発火条件: touch のみ・単指・水平優位 |dx| > |dy|×1.5 かつ |dx| > 70px。
     判断報告: PC はタブクリックが主導線のためマウスドラッグ非対応
   - passive リスナーのみ・preventDefault なし = 縦スクロール非阻害。ピンチ移行（2指）で即中止
   切替演出は追加しない（判断報告: タブタップ時と完全同一の即時切替に統一 — 0.3s 以下の
   追加スライド演出も不採用。reduced-motion 配慮は既存共通則のまま・1タップ即動作原則も不変）
============================================================ */
(function(){
  'use strict';
  /* 2026-07-27 クライアント指示: MIX タブ追加に伴い横フリック順の末尾へ mix を追加（上部タブ視覚順 CLUB/LABEL/VISUAL/SHOP/CHART/MIX と同期・端で停止/ラップなしは不変） */
  /* 2026-07-27(2) クライアント裁定（MIX 上タブ撤去・5タブ復帰）: 横フリック順から mix を除去（ドロワーはビューではないためフリック遷移対象外）。EXCLUDE に .player-drawer を追加＝ドロワー展開中のフリックが背後ビューへ漏れない（bio-overlay 同様の隔離） */
  /* 2026-08-01 SHOP v3「3D 軌道」移植: EXCLUDE に #shopStage を追加。
     ★ 追加しないと SHOP で横フリックするたびに隣のタブへ飛ぶ ★
       v2（2軸カルーセル）では SHOP の横ジェスチャ面 .card-row が overflow-x:auto で実際に
       横オーバーフローを持っていたため、下の excluded() の「保険」節（祖先に横スクロール実容量が
       あれば対象外）が自動的に効いていた。v3 の軌道は overflow を一切使わず pointer events だけで
       回すので、その保険に掛からない＝明示的な除外が必要になる。
       なお軌道側（assets/asf-shop-orbit-1.js）は横確定後に毎 touchmove で preventDefault するが、
       本 IIFE は passive リスナで touch の座標を読むだけなので preventDefault では止まらない
       （＝JS 側の対処では防げない。ここで除外するのが唯一の正しい場所）。
     ★ 除外範囲 ★ #shopStage（= .stage・1 画面ぶんの軌道ステージ）のみ。その外側
       （A.S.F. LIST 帯・フッター）では従来どおり横フリックでタブ移動できる。 */
  /* 2026-08-05 世代 -35 LOOKS 全画面ビューワー: EXCLUDE に .look-viewer を追加（1 行のみの改変）。
     ★ 追加しないとビューワー上の横フリックが「隣のタブへ移動」に奪われる ★
       ビューワー（assets/asf-look-viewer-1.js）は #shopStage と同じく overflow を一切使わず
       pointer events だけで捲るので、下の excluded() の「保険」節（祖先に横スクロール実容量が
       あれば対象外）に掛からない＝明示的な除外が必要。ビューワー側は横確定後に毎 touchmove で
       preventDefault するが、本 IIFE は passive リスナで座標を読むだけなので止められない
       （#shopStage 追加時とまったく同じ構造。ここで除外するのが唯一の正しい場所）。
     ★ 既定 / neuedin では恒偽 ★ .look-viewer の DOM は soehne モードでしか生成されないので、
       既定モードでは el.matches(EXCLUDE) の結果が 1 ノードたりとも変わらない（完全に不活性）。 */
  var VIEWS = ['club','label','visual','chart','shop']; /* 2026-08-04 タブ入替(CHART⇄SHOP)に同期 */
  var EXCLUDE = '#lookCarousel, .flyer-strip, .mix-player, .look-lightbox, .look-viewer, .video-modal, .quicknav__panel, .player-drawer, #shopStage, [role="slider"]';
  var THRESH_X = 70, RATIO = 1.5;
  var startX = 0, startY = 0, lastX = 0, lastY = 0, tracking = false;
  function excluded(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while(el && el !== document.documentElement){
      if(el.matches && el.matches(EXCLUDE)) return true;
      try{
        var cs = getComputedStyle(el);
        if((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 1) return true;
      }catch(e){}
      el = el.parentElement;
    }
    return false;
  }
  /* ══════════════════════════════════════════════════════════════════════════
     2026-08-08 クライアント裁定（原文「スマホ版でタブをフリックで切り替えたとき、
     その項目に切り替わったらトップから表示」）— フリック確定時に、切替先ビューの先頭へ即時ジャンプ。
     ★ 切替そのものは無改変 ★ 従来どおり location.hash 代入＝既存ハッシュルーター経由。
       ハッシュ・履歴・GA 仮想 page_view（route() が送る）・タブ点灯は 1 行も触っていない。
     ★ なぜルーター側の scrollTo だけでは足りないか ★
       snippets/asf-overlay-host.liquid の route() は既にビュー変更時に
       window.scrollTo({top:0, behavior:'instant'}) を呼ぶ。しかし **フリックの場合だけ** その後から
       scrollY を書き戻すものが 2 つある:
         ① touchend の直後にブラウザが立ち上げる慣性スクロール（fling）。フリックは水平優位
            （|dx| > |dy|×1.5）でも dy は 0 ではないので、必ず縦の初速が乗る。ルーターの
            scrollTo は hashchange（＝ touchend と同フレーム）で走り、fling はその後も続くため、
            切替先ビューが下へ流れて「途中に着地」する。
         ② フラグメント遷移に伴うブラウザ自前のスクロールが hashchange の後に来る場合がある。
       どちらも「後から」なので、確定直後の 1 回では足りない。**先頭に居座り続ける短い監視窓**で
       打ち消す（実測: 6 フレーム＝約 100ms の固定では、素早い連続フリックのとき fling が
       窓を食い破って 100〜145px 流れた。監視窓を持たせて「動いたら即座に引き戻す」形にすると 0px）。
       窓は ①先頭のまま 8 フレーム静かなら即終了（慣性が死んだ＝居座る理由が無い）
           ②最長 600ms で必ず終了（暴走しない上限）
           ③次の touchstart で即終了（下記 token・ユーザーの指と喧嘩しない）。
     ★ スムーススクロールは使わない ★ behavior:'instant'（即応の家風。タブ帯タップ時の即時切替と
       体感を揃える ＝ 上のヘッダで既に「0.3s 以下の追加スライド演出も不採用」と決めている判断の延長）。
       'instant' を知らない旧 Safari は TypeError を投げるので、ルーターと同じ try/catch 二段構え。
     ★ 指と喧嘩しない ★ 次の touchstart が来た時点で反復を打ち切る（token 方式）。切替直後に
       ユーザーが自分でスクロールを始めたら即座に手を離す。
     ★ 無干渉 ★ 呼ぶのは window.scrollTo だけ。永続オーディオ層（§I1）・LookBook / #shopStage 等の
       EXCLUDE・3D・ドロワー・オーバーレイのいずれにも触れない純粋な追加。
     ★ タブ帯タップは対象外 ★ 本 IIFE は touch ジェスチャ由来の切替にしか関与しないので、
       タップ切替の現挙動は 1px も変わらない（裁定はフリックに限定されているため意図的に揃えない）。
     ══════════════════════════════════════════════════════════════════════════ */
  var topToken = 0;
  function scrollTopInstant(){
    try{ window.scrollTo({ top:0, left:0, behavior:'instant' }); }
    catch(e){ window.scrollTo(0, 0); }
  }
  function nowMs(){
    return (window.performance && performance.now) ? performance.now() : +new Date();
  }
  function jumpToViewTop(){
    var mine = ++topToken, t0 = nowMs(), quiet = 0;
    scrollTopInstant();                          /* ★ 即時ジャンプ本体（これが裁定の実装） */
    (function watch(){
      if(mine !== topToken) return;              /* 次の touchstart / 次のフリックで失効 */
      var y = window.scrollY || window.pageYOffset || 0;
      if(y !== 0){ quiet = 0; scrollTopInstant(); }   /* 慣性が動かした → 引き戻す */
      else if(++quiet >= 8) return;                   /* 8 フレーム先頭のまま = 慣性は死んだ */
      if(nowMs() - t0 < 600) requestAnimationFrame(watch);  /* 監視窓の上限 */
    })();
    /* 遅れて 1 回だけ来るもの（画像等の読込完了後にブラウザがもう一度フラグメントへ寄せる場合）を拾う。
       実測: 連続フリックで CLUB→…→SHOP と渡ったあと、切替の約 1 秒後に 28px ずれることがあった。
       上の rAF 監視窓は「慣性が死んだら即終了」する設計なのでこの一発には届かない。
       token が生きていて（＝ユーザーが触っていない）かつ先頭から外れている時だけ静かに戻す。 */
    setTimeout(function(){ if(mine === topToken && (window.scrollY || window.pageYOffset || 0) !== 0) scrollTopInstant(); }, 400);
    setTimeout(function(){ if(mine === topToken && (window.scrollY || window.pageYOffset || 0) !== 0) scrollTopInstant(); }, 1200);
  }
  /* ホイール（タッチ対応ノート PC 等）でも先頭固定を手放す。touch 端末では touchstart が先に来るので
     実質の出番は無いが、「ユーザーの能動的なスクロールとは絶対に喧嘩しない」を機構で担保する 1 行。 */
  window.addEventListener('wheel', function(){ topToken++; }, { passive:true });
  window.addEventListener('touchstart', function(e){
    topToken++;                                  /* ユーザーが触った ＝ 先頭固定の反復を打ち切る */
    if(e.touches.length !== 1 || excluded(e.target)){ tracking = false; return; }
    tracking = true;
    startX = lastX = e.touches[0].clientX;
    startY = lastY = e.touches[0].clientY;
  }, { passive:true });
  window.addEventListener('touchmove', function(e){
    if(!tracking) return;
    if(e.touches.length !== 1){ tracking = false; return; } /* ピンチ移行で中止 */
    lastX = e.touches[0].clientX;
    lastY = e.touches[0].clientY;
  }, { passive:true });
  window.addEventListener('touchcancel', function(){ tracking = false; }, { passive:true });
  window.addEventListener('touchend', function(){
    if(!tracking) return;
    tracking = false;
    var dx = lastX - startX, dy = lastY - startY;
    if(Math.abs(dx) < THRESH_X || Math.abs(dx) <= Math.abs(dy) * RATIO) return; /* 水平優位のみ */
    var active = document.querySelector('.view.is-active');
    var idx = active ? VIEWS.indexOf(active.id) : -1;
    if(idx === -1) return;
    var next = idx + (dx < 0 ? 1 : -1); /* 左フリック = 右隣（次）のタブへ */
    if(next < 0 || next >= VIEWS.length) return; /* 端で停止・ラップなし */
    location.hash = '#' + VIEWS[next];
    jumpToViewTop();   /* 2026-08-08 裁定: フリック切替の確定時はそのビューの先頭から表示（上の経緯コメント参照） */
  }, { passive:true });
})();
});

/* ==== [05] / [06] — 2026-07-31 SHOP v2 移植 B2 で撤去 ====
   ══════════════════════════════════════════════════════════════════════════
   ここには原本 sections/asf-index.liquid L2906-3089 由来の SHOP 専用 IIFE が 2 本あった。
   どちらも SHOP v2（docs/SHOPV2-PORT-PLAN.md §1-d / §5-B2）で役目を終えたため削除する。

   [05] SHOP — 背景動画（#shopBgVideo）
     Save-Data/低帯域スキップ・IntersectionObserver での遅延 fetch・playbackRate 0.6 の
     ratechange 監視・visibilitychange での再開・恒久ルールに基づく無音化の二重強制を持っていた。
     → 背景が「動画」から「全画面 WebGL 柄」へ変わり、対象要素 #shopBgVideo が DOM から
       消えたので丸ごと撤去。後継は assets/asf-shop-bg-2.js（window.ASF_SHOP_BG）。
     ★ 撤去は不変条件 I1（音声）に対して安全側の変更 ★ 消えたのは「恒久・音声を鳴らさない
       規則のために JS 側で二重 mute していた装飾動画」であり、音源そのものには元々無関係。
       置き換え先の canvas には media 要素が 1 つも無い＝違反リスクは減るだけ。
     ★ 対になる撤去 ★ snippets/asf-overlay-host.liquid の activate() 内 #shopBgVideo
       play/pause 3 行（§1-d-2 / §R11）→ ASF_SHOP_BG.start()/stop() へ差し替え済み。
       assets/asf-theme-4.css の .shop-bg / .shop-bg-dim 規則も撤去済み。
     ★ Files の asf-bg-vid-03.mp4 / poster は残置 ★（§4・--nodelete 運用・他用途/復活用）。

   [06] SHOP カード — フリップ / チップ委譲 / PC クリック代理発火 / 初回ヒント
     ・.buy-chip の pointerdown/click stopPropagation … INFO チップが DOM から消えたため不要
       （§I3 の再確認: このハンドラは GA を 1 件も送っていなかったので GA は非退行）。
     ・PC カードクリックで chip.click() を代理発火 … SHOP v2 はカード全体が
       a.card-link[href="/products/〈handle〉"] になったので、**代理発火という仕組み自体が不要**。
       「実ナビゲーションではなく 〈a〉 のクリックとしてルーターの capture 段に拾わせる」という
       設計意図（＝音が途切れない・GA が飛ぶ）は、素の 〈a href〉 になったことでより直接的に
       満たされる（§R2）。ここに location.href 系の遷移を書いてはいけない、という不変条件は不変。
     ・SP の toggleFlip / is-tapping の押し込みフィードバック / keydown / contextmenu 抑制
       … カードは role="button" / tabindex="0" を持たない 〈a〉 になり、フリップ状態の管理も
       「行 + handle」単位（クローンと同期）へ設計が変わったため、assets/asf-shop-grid-2.js が
       まとめて所有する。is-tapping は §C2 の確認事項どおり撤去（ラボは未使用）。
     ・.card__hint の生成（1 枚目カード限定の初回ヒント）… SHOP 専用の演出なので
       assets/asf-shop-grid-2.js へ移設。文言も PC/SP で出し分ける仕様に変わった。
     ★ CSS 側 ★ .card-wrap.is-tapping / .card-wrap.is-flipped .card（ready-pulse）の規則本体は
       assets/asf-theme-4.css に残置してあるが、SHOP では #shop スコープで無効化済み。

   ★ 復活が必要になったら ★ theme-v3-backup-20260731-preport/assets/asf-index.js の L1433-1663。
   ══════════════════════════════════════════════════════════════════════════ */

/* ==== [07] 原本 sections/asf-index.liquid L3092-3173 ==== */
/* ============================================================
   RECORDS ジャケット拡大 / DISCOGRAPHY 開閉 / PHOTO ライトボックス結線
   出典: demo-v3 index.html「BRIEF10 — VINYL ジャケット拡大 + PHOTO 自動グリッド」IIFE。

   - ジャケット: 共有ライトボックス（window.asfViewer）で表/裏 2枚を閲覧
   - DISCOGRAPHY: max-height トランジションのアコーディオン（開き切ったら none にして高さ自由）
   - PHOTO: グリッドのセルをクリック → 共有ライトボックス

   theme-v3 での変更点:
     ① asfBoot() で包む + シングルトン・ガード（§(h) h-5）。
     ② ジャケットの表/裏 URL を JS 直書き → ボタンの data-front / data-back（Liquid の asset_url）から読む。
     ③ PHOTO は fetch HEAD の連番プローブを廃止（Shopify にディレクトリ概念が無く 18 枚は確定のため
        Liquid が 3×6 を静的描画する）。JS は DOM の .photo-cell[data-full] から entries を組み立てるだけ。
============================================================ */
window.asfBoot(function(){
  'use strict';
  if (window.__asfBootRecordPhoto) return;
  window.__asfBootRecordPhoto = true;

  /* ---------- RECORDS: ジャケット拡大（表 → 裏） ---------- */
  var recordZoom = document.getElementById('recordZoomNeuromancer');
  if(recordZoom){
    recordZoom.addEventListener('click', function(){
      if(!window.asfViewer) return;
      var front = recordZoom.getAttribute('data-front');
      var back  = recordZoom.getAttribute('data-back');
      var list = [];
      if(front) list.push({ full:front, alt:'Neuromancer EP — jacket front' });
      if(back)  list.push({ full:back,  alt:'Neuromancer EP — back' });
      if(list.length) window.asfViewer.open(list, 0);
    });
  }

  /* ---------- 汎用アコーディオン（max-height トランジション） ---------- */
  function bindCollapse(toggle, panel){
    if(!toggle || !panel) return;
    panel.addEventListener('transitionend', function(e){
      if(e.propertyName !== 'max-height') return;
      /* 開き切ったら max-height を解除＝中身が伸びても切れない */
      if(toggle.getAttribute('aria-expanded') === 'true'){ panel.style.maxHeight = 'none'; }
    });
    toggle.addEventListener('click', function(){
      var open = toggle.getAttribute('aria-expanded') === 'true';
      if(open){
        panel.style.maxHeight = panel.scrollHeight + 'px';
        void panel.offsetHeight;                       /* 現在高さを確定させてから 0 へ（アニメ成立） */
        requestAnimationFrame(function(){ panel.style.maxHeight = '0px'; });
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }
  bindCollapse(document.getElementById('recordDescToggle'), document.getElementById('recordDescPanel'));
  /* 同型の折りたたみ（.artist-toggle / #bgToggle）は index シェルには実在しないが、
     demo の共通ブロックをそのまま温存する（他テンプレートへ移送する際の参照実装）。 */
  Array.prototype.forEach.call(document.querySelectorAll('.artist-toggle'), function(tg){
    bindCollapse(tg, document.getElementById(tg.getAttribute('aria-controls')));
  });
  bindCollapse(document.getElementById('bgToggle'), document.getElementById('brandGuidelinesPanel'));

  /* ---------- PHOTO: サーバー描画済みグリッド → 共有ライトボックス ---------- */
  var grid = document.getElementById('partyPhotoGrid');
  if(!grid) return;
  var cells = Array.prototype.slice.call(grid.querySelectorAll('.photo-cell'));
  if(!cells.length) return;
  var entries = cells.map(function(cell, i){
    var im = cell.querySelector('img');
    return {
      full: cell.getAttribute('data-full') || (im ? im.getAttribute('src') : ''),
      alt:  im ? im.alt : ('A.S.F. party photo ' + (i + 1))
    };
  });
  cells.forEach(function(cell, i){
    cell.addEventListener('click', function(){
      /* 2026-07-29 クライアント指示: **PHOTO の拡大表示は黒バックへ**（旧: 白バック）。
         ── 何を変えたか ── viewer.open の第4引数から { theme:'light' } を落としただけ。
            共有ビューア（window.asfViewer）は open() で
              lightbox.classList.toggle('is-light', opts && opts.theme === 'light')
            しているので、opts を渡さなければ **既定＝黒テーマ**（.look-lightbox の
            background:#000／× と前後矢印とカウンターは color:var(--ink)=#F5F5F5＝白）になる。
            新しいテーマ文法は一切足していない — ARCHIVE のフライヤー群・NEXT PARTY の単票拡大・
            WOMB の tapCycle が元から使っている「引数なし＝黒」呼び出しと**同じ形**に揃えただけ。
         ── 旧コメント（履歴）── 「theme:'light' = 白基調ライトボックス（demo と同一・PHOTO のみ）」。
            白は 2026-07-21(16) の「VISUAL 起点のライトボックスは白バック＋黒操作系」という
            当時の裁定に由来する。本指示はその裁定のうち **PHOTO 起点だけ**を上書きするもの。
         ── 巻き添えにしていないもの ── 商品/ bio オーバーレイ側の LOOK 写真拡大
            （snippets/asf-overlay-host.liquid の viewer.open(..., { theme:'light' })）は**不変**＝
            白バックのまま。よって .look-lightbox.is-light の CSS 一式も現役（dead 化していない）。 */
      if(window.asfViewer){ window.asfViewer.open(entries, i); }
    });
  });
});

/* ==== [08] 原本 sections/asf-index.liquid L3176-3251 ==== */
/* ============================================================
   ARCHIVE — フライヤーギャラリー → 共有ライトボックス統合
   出典: demo-v3 index.html「ARCHIVE — フライヤーギャラリー」IIFE。
   （前後移動 / ESC / ピンチズームは共有ビューア window.asfViewer が担う）

   theme-v3 での変更点:
     ① asfBoot() で包む + シングルトン・ガード（§(h) h-5）。
     ② demo は galleries = ["img/flyers/mitsuki-01.jpg", …] を JS に直書きしていた。
        Shopify では URL が Shopify Files の CDN（snippets/asf-media-urls.liquid 由来）になるため、
        **DOM から組み立てる**（.flyer-frame img の src がそのまま拡大用の実 URL＝demo と完全同値。
        demo でも galleries の各要素は同じファイルを指していた）。
        → URL の真実源は Liquid 側 1箇所のみ。JS には URL を一切書かない。
     ③ 単票拡大（bindStill）も同じ理由で、対象要素（またはその中の img）の src を読む。
============================================================ */
window.asfBoot(function(){
  'use strict';
  if (window.__asfBootArchive) return;
  window.__asfBootArchive = true;

  function pad2(n){ return (n < 10 ? '0' : '') + n; }

  /* data-gallery ごとに、その帯の .flyer-frame img から実 URL を収集（描画順＝data-index 順） */
  var entriesCache = {};
  function entriesFor(g){
    if(!entriesCache[g]){
      var figs = Array.prototype.slice.call(document.querySelectorAll('#archive [data-gallery="' + g + '"]'));
      figs.sort(function(a, b){
        return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0);
      });
      entriesCache[g] = figs.map(function(fig, i){
        var im = fig.querySelector('img');
        return { full: im ? im.getAttribute('src') : '', alt: (im && im.alt) || (g + ' flyer ' + pad2(i + 1)) };
      }).filter(function(e){ return !!e.full; });
    }
    return entriesCache[g];
  }

  document.querySelectorAll('#archive [data-gallery]').forEach(function(fig){
    function openIt(){
      if(!window.asfViewer) return;
      var g = fig.getAttribute('data-gallery');
      var list = entriesFor(g);
      if(!list.length) return;
      window.asfViewer.open(list, parseInt(fig.getAttribute('data-index'), 10) || 0);
    }
    fig.addEventListener('click', openIt);
    fig.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openIt(); }
    });
  });

  /* 単票拡大: NEXT PARTY フライヤー / ゲスト写真 / UPCOMING(WOMB) フライヤー。
     拡大画像は「その場に出ている img と同じファイル」＝ demo と同一（demo も同じパスを渡していた）。 */
  function bindStill(id){
    var el = document.getElementById(id);
    if(!el) return;
    var im = (el.tagName === 'IMG') ? el : el.querySelector('img');
    if(!im) return;
    function openIt(){
      var full = el.getAttribute('data-full') || im.getAttribute('src');
      if(full && window.asfViewer){ window.asfViewer.open([{ full: full, alt: im.alt || '' }], 0); }
    }
    el.addEventListener('click', openIt);
    el.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openIt(); }
    });
  }
  bindStill('npHeroStill');
  bindStill('npGuestPhoto');
  bindStill('wombUpcomingFlyer');
  /* MAGO の UPCOMING フライヤーが用意できたら、マークアップ側で
     .club-upcoming__flyer-reserve を <img id="magoUpcomingFlyer" …> に差し替え、
     ここに bindStill('magoUpcomingFlyer'); を1行足すだけでよい（WOMB と完全同一フック）。 */
});

/* ==== [09] 原本 sections/asf-index.liquid L3254-3292 ==== */
/*
  [theme-v3 / Batch 1] WOMB フライヤーの tapCycle 拡大（表 → 裏 → 閉じる）
  出典: demo-v3 index.html の同名 IIFE を **逐語移送**（ロジック無改変）。
  theme-v3 での唯一の変更は次の2点だけ:
    (1) window.asfBoot(...) で包む — このセクションは content_for_layout の中で描画され、
        demo のように </body> 直前で DOM が揃っている保証が無いため（§(h) h-5）。
    (2) window.__asfBootWombFlyerCycle のシングルトン・ガード（二重マウント事故の構造的排除）。
  表/裏の URL はマークアップの data-front / data-back（Liquid 由来）から読むため無改変で成立。
*/
window.asfBoot(function(){
  if (window.__asfBootWombFlyerCycle) return;
  window.__asfBootWombFlyerCycle = true;

/* ============================================================
   WOMB FLYER TAP CYCLE — 2026-07-21(4) クライアント指示（めくり回転の全面置換）:
   ストリップのサムネをタップ → 共有ビューア（asfViewer）の tapCycle モードで
   表面を拡大表示 → 表示中タップ = 裏面へ → さらにタップ = 閉じる。
   ESC / × はビューア既存ハンドラで常時閉。前後矢印は is-cycle CSS で非表示
============================================================ */
(function(){
  'use strict';
  document.querySelectorAll('[data-womb-pair]').forEach(function(fig){
    function openIt(){
      if(!window.asfViewer) return;
      var label = fig.getAttribute('data-label') || 'WOMB flyer';
      window.asfViewer.open([
        { full: fig.getAttribute('data-front'), alt: label + ' — front' },
        { full: fig.getAttribute('data-back'),  alt: label + ' — back' }
      ], 0, null, { tapCycle: true });
    }
    fig.addEventListener('click', openIt);
    fig.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openIt(); }
    });
  });
})();
});

/* ==== [10] 原本 sections/asf-index.liquid L3295-3333 ==== */
/* ============================================================
   CLUB「LIVE MIX」の 3 カード（#clubGPlayer / #clubKinoPlayer / #clubRyokeiPlayer）を
   LIVE MIX エンジンのミラーとして結線。THEME-V3-DESIGN.md §(h) h-3 の中核。

   ★ 音の実体はここには無い ★
     demo-v3 では CLUB の #mixPlayer カード DOM に 〈audio〉 を作る IIFE が同居していた
     （先頭で `if(!playerEl || !waveEl || !canvas || !listEl) return;`）。Shopify では
     このカードは index テンプレート（content_for_layout の中）にしか存在しないため、
     そのままでは legal / brand / vinyl / product / cart で LIVE MIX が死に、§(e) の
     「全ページ常駐 + sessionStorage 復帰」が成立しない。
     → エンジン（〈audio〉・トラック定義・peaks・復帰・アーム）は
       snippets/asf-audio-layer.liquid（全ページ常駐）へ移した。ここは **UI（リモコン）だけ**。

   ★ 2026-07-31 クライアント指示（LIVE MIX 3 分割を CLUB にも反映）★
     旧: 1 枚の切替式カードを asfLiveMixMirror('mix', {armOnVisible:true}) で 1 回結線。
     新: トラック固定の 3 枚を asfLiveMixMirror(prefix, {track:n, duration:d, armOnVisible:true})
         で 3 回結線（prefix=clubG / clubKino / clubRyokei）。
     ★ それでも 〈audio〉 は 1 本のまま ★ CLUB 3 枚 + PLAYER BOX ドロワー 3 枚 = 計 6 枚は
       すべて同一エンジンのリモコンで、同一トラックの進行は 6 枚すべてに同時に映る
       （全ミラーが同じ API.getState() を読み、同じ API.onUpdate 通知を受けるため構造的に同期）。
       audio を増やす経路はこのファイルにもエンジンにも無い＝§(g) double audio は原理的に起きない。

   opts:
     track:n … そのカードが指す #asfLiveMixTracks の位置（0=LIVE THREE G / 1=LIVE TWO KINO /
       2=LIVE ONE RYOKEI）。エンジン側 〈ol〉 の順序が唯一の真実源なので増減時はここも 1:1 で合わせる。
     duration:d … そのトラックの全長（秒）。非アクティブ時の「0:00 / 全長」表示用の初期値で、
       出典は assets/live-*.peaks.json の duration（19164.5 / 4947.264 / 14433.376）の切り捨て。
       カード内表記 5:19:24 / 1:22:27 / 4:00:33 と fmt() で完全一致する。
     armOnVisible:true … CLUB の LIVE MIX セクションが可視域に入った時点で .m4a をアーム
       （＝遅延ロードの発火点。demo は カード.closest('section') を IO で監視していたのと同じ挙動）。
       3 枚とも指定するが armAudio() は audioArmed で冪等＝実アームは最初の 1 回だけ（旧 1 枚時と同挙動）。
     lockWaveUntilPlayed は **付けない** — 波形の誤操作ガードはクライアント裁定により
       ドロワー内カード限定（demo の drawer フラグ）。CLUB カードは従来どおり即スクラブ可
       （ただしトラック束縛モードでは「自分の曲が現在トラックでない間」は常時ロック＝
       静止波形を掴んでも他曲の再生位置は動かない。これは 3 分割に伴う新しい不変条件）。

   実行順: asfBoot のキューは登録順。asf-audio-layer.liquid（エンジン）は layout で
   content_for_layout より前に render されるため、この時点で window.asfLiveMix は必ず存在する。
============================================================ */
window.asfBoot(function(){
  'use strict';
  if (window.__asfBootClubMixMirror) return;   /* シングルトン・ガード（二重束縛は factory 側でも弾かれる） */
  window.__asfBootClubMixMirror = true;

  if(!window.asfLiveMixMirror) return;         /* エンジン未搭載ページでは無害に no-op */
  /* 2026-08-20 クライアント裁定（逐語）「CLUBのGUEST — KINOのSOUNDCLOUD ↗とBIOの本文の間に
     player box内のKINOのプレイヤーを貼り付けてください」: GUEST — KINO 区画の紹介文の下に
     置いた 4 枚目のカード（#guestKinoPlayer・snippets/asf-tab-club.liquid）を同じ配列で束ねる。
     ★ 追記はこの 1 行だけ ★ ミラー・ファクトリ（asf-audio-layer.liquid ③）も、その下の
       結線ループも 1 バイト触っていない。track:1 は KINO ＝ ドロワーの mixKino / 本セクションの
       clubKino と同じトラックで、**同じ 1 本の 〈audio〉 に対する 3 枚目のリモコン**になる
       （同一トラックに複数のリモコンが並ぶ形は 2026-07-31 の 5 カード化で既に成立している構造）。
     ★ duration は他 2 枚と同値 ★ live-two-kino.peaks.json の 4947.264 秒の切り捨て＝
       カード表記 1:22:27 と fmt() で完全一致。
     ★ lockWaveUntilPlayed は付けない ★ CLUB 面のカードは即スクラブ可（ドロワー限定の裁定）。
       束縛モードの「自分の曲が現在トラックでない間は施錠」は factory 側が自動で担保する。 */
  var CLUB_LIVE_CARDS = [
    { prefix:'clubG',      track:0, duration:19164 },  /* A.S.F.RECS LIVE THREE G    — 5:19:24 */
    { prefix:'clubKino',   track:1, duration:4947  },  /* A.S.F.RECS LIVE TWO KINO   — 1:22:27 */
    { prefix:'clubRyokei', track:2, duration:14433 },  /* A.S.F.RECS LIVE ONE RYOKEI — 4:00:33 */
    { prefix:'guestKino',  track:1, duration:4947  }   /* GUEST — KINO 区画のカード（2026-08-20 裁定） */
  ];
  var clubMirrors = [];
  CLUB_LIVE_CARDS.forEach(function(c){
    var m = window.asfLiveMixMirror(c.prefix, { track:c.track, duration:c.duration, armOnVisible:true });
    if(m) clubMirrors.push(m);
  });
  /* 名前は従来どおり asfMixRender（幅確定後の再描画フック）。参照はこのファイル内で閉じている。 */
  window.asfMixRender = function(){ for(var i=0;i<clubMirrors.length;i++){ clubMirrors[i].render(); } };
});

/* ==== [11] 原本 sections/asf-index.liquid L3336-3535 ==== */
/* ============================================================
   VIDEO — WOMB gallery: IO プレビュー自動再生 + モーダル + 音源排他
   出典: demo-v3 index.html「VIDEO — WOMB gallery」IIFE。

   theme-v3 での変更点:
     ① asfBoot() で包む + シングルトン・ガード（§(h) h-5）。
     ② 動画 src はテーマアセットではなく window.ASF_MEDIA（Shopify Files CDN・§(h) h-1/h-2）。
        ポスター（各 <130KB）はテーマアセットのまま asset_url。URL 未設定のタイルは描画しない
        （＝Files 未アップロード時にリンク切れタイルを並べない）。
     ③ グリッドのプレビュー動画は muted + volume=0 を JS でも明示強制（恒久・音声を鳴らさない規則）。

   ★ モーダル（ユーザーがタイルを明示クリックした時だけ開く）は demo と同じく音を出す ★
     これは装飾の自動再生ではなく「ユーザーが選んで再生する映像作品」であり、demo-v3=デザイン真実源が
     そう設計している（openVideo で muted=false / volume=1）。自動再生・背景・プレビューの類は
     すべて無音のまま。※この1点は §(h) にも demo にも変更指示が無いため demo 準拠で移送した。
   ★ 排他 ★ モーダルを開く前に window.scWidget（= LIVE MIX 互換シム）を pause し、閉じたら復帰。
     これは「音源を止める」のではなく「可聴を1つに保つ」ための demo 由来の正規経路（I1 とは別レイヤ）。
============================================================ */
window.asfBoot(function(){
  'use strict';
  if (window.__asfBootVideoGallery) return;
  window.__asfBootVideoGallery = true;

  var MEDIA = window.ASF_MEDIA || {};
  /* ── Liquid → JS の受け渡し（HOTFIX 2.5）──────────────────────────────
     もとはこの位置に {%- for -%} を書いて VIDEOS 配列を Liquid が直接出力していた。
     JS を assets/asf-index.js（= Liquid 非通過の素の .js）へ出した以上、Liquid 由来の値は
     セクション側の小さなインラインブロックが定義する window.ASF_INDEX 経由で受け取る。
     渡す中身は完全同値: id（'01'…'06'）/ mediaKey（'womb-01.mp4'…）/ poster（asset_url）。
     src の解決（MEDIA[key] || ''）と .filter(!!src) も原本と同一の順序・意味で行う
     ＝ Files 未アップロード時にリンク切れタイルを並べない挙動は不変。 */
  var ASF_IDX = window.ASF_INDEX || {};
  var VIDEOS = (ASF_IDX.videos || []).map(function(v){
    return { id: v.id, src: MEDIA[v.mediaKey] || '', poster: v.poster };
  }).filter(function(v){ return !!v.src; });

  var grid     = document.getElementById('videosGrid');
  var modal    = document.getElementById('videoModal');
  var modalVid = document.getElementById('videoModalEl');
  var closeBtn = document.getElementById('videoModalClose');
  if(!grid || !modal || !modalVid) return;

  var thumbVideos = [];
  VIDEOS.forEach(function(v){
    var tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'video-tile';
    tile.setAttribute('aria-label', 'Play video ' + v.id);
    var vid = document.createElement('video');
    vid.dataset.src = v.src;
    vid.poster = v.poster;
    vid.muted = true;
    vid.defaultMuted = true;
    try{ vid.volume = 0; }catch(e){}                 /* 恒久・音声を鳴らさない規則（プレビューは常に無音） */
    vid.loop = true;
    vid.playsInline = true;
    vid.setAttribute('playsinline', '');
    vid.setAttribute('webkit-playsinline', '');
    vid.setAttribute('muted', '');
    vid.preload = 'none';
    vid.setAttribute('aria-hidden', 'true');
    vid.setAttribute('disablepictureinpicture', '');
    tile.appendChild(vid);
    thumbVideos.push(vid);
    tile.addEventListener('click', function(){ openVideo(v); });
    grid.appendChild(tile);
  });

  function ensureSrc(v){
    if(!v.src && v.dataset.src){ v.src = v.dataset.src; }
  }

  /* IO: 見えたらプレビュー再生、外れたら停止（reduced-motion では一切自動再生しない） */
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!prefersReduced && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var v = entry.target;
        if(entry.isIntersecting){
          ensureSrc(v);
          v.muted = true; try{ v.volume = 0; }catch(e){}
          var p = v.play();
          if(p && p.catch) p.catch(function(){});
        } else {
          v.pause();
        }
      });
    }, { threshold:0.25 });
    thumbVideos.forEach(function(v){ io.observe(v); });
  }

  var scWasPlayingBeforeVideo = false;
  var closing = false;
  var closeTimer = null;   /* 2026-08-14 裁定④: closeVideo の 400ms クールダウンの手綱 */

  function requestModalFullscreen(){
    try{
      var req = modal.requestFullscreen || modal.webkitRequestFullscreen;
      if(req){ var p = req.call(modal); if(p && p.catch) p.catch(function(){}); }
    }catch(e){}
  }
  function exitModalFullscreen(){
    try{
      var isFs = document.fullscreenElement || document.webkitFullscreenElement;
      if(isFs){
        var exit = document.exitFullscreen || document.webkitExitFullscreen;
        if(exit){ var p = exit.call(document); if(p && p.catch) p.catch(function(){}); }
      }
    }catch(e){}
  }
  function enterNativeVideoFullscreen(){
    try{ if(modalVid.webkitEnterFullscreen) modalVid.webkitEnterFullscreen(); }catch(e){}
  }
  function exitNativeVideoFullscreen(){
    try{ if(modalVid.webkitExitFullscreen) modalVid.webkitExitFullscreen(); }catch(e){}
  }

  function openVideo(v){
    /* 可聴の一本化: LIVE MIX が鳴っていたら退避して pause（閉じたら復帰） */
    if(window.scWidget){
      try {
        window.scWidget.isPaused(function(paused){
          scWasPlayingBeforeVideo = !paused;
          if(!paused) window.scWidget.pause();
        });
      } catch(e){}
    }
    /* 2026-08-14 裁定④「中央と右の動画は再生されない／時間がかかる／たまに再生される」対応 ①
       ★ 直前の closeVideo が張った 400ms のクールダウンを打ち切る ★
       closeVideo は removeAttribute('src') → load() という **非同期のリセット**を投げてから
       400ms 後に closing を戻す。openVideo はこのタイマを見ていなかったので、閉じた直後の
       タップでは「前のリセットが飛んでいる最中に新しい src と play() が割り込む」形になり、
       play() が中断（AbortError）で reject される経路が開いていた。タイマを明示的に潰してから
       進むことで、この競合の入口を閉じる。セッション最初の 1 本（＝ユーザーの言う「一番左」）
       だけが速かったのは、そこだけ直前の closeVideo が無かったためである。 */
    if(closeTimer){ clearTimeout(closeTimer); closeTimer = null; }
    closing = false;
    /* 2026-08-14 裁定④ ② ポスターを敷く ―― 「押しても何も起こらない」の正体を消す。
       モーダルの 〈video〉 は preload="none" なので、押した直後はメタデータすら無く
       **純黒**のまま数秒待つことがあった（バッファ表示は無い）。押したタイルと同じ絵を
       即座に出せば、待っている間も「開いている」ことが目で分かる。
       ★ 新しい意匠はゼロ ★ poster は VISUAL のタイルが既に持っているデータ（v.poster）で、
       CLUB は下のトリガ側がタイルの 〈img〉 から同じ画をそのまま渡す。 */
    if(v.poster) modalVid.poster = v.poster; else modalVid.removeAttribute('poster');
    /* 2026-08-14 裁定④ ③ 開いた瞬間だけ preload を上げる。HTML 側の preload="none"
       （＝触るまで 1 バイトも落とさない設計）は据え置き、押された 1 本にだけ 'auto' を与える。 */
    modalVid.preload = 'auto';
    modalVid.muted = false;      /* ユーザーが明示的にタイルを押した映像作品の再生（demo=デザイン真実源と同一） */
    modalVid.volume = 1.0;
    modalVid.loop = false;
    modalVid.src = v.src;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('video-open');
    requestModalFullscreen();
    playModal(v.src, true);
  }
  /* 2026-08-14 裁定④ ④ play() の失敗を握りつぶさない ―― 1 回だけ自力で建て直す。
     従来は `p.catch(function(){})` で **完全に無言**だった。競合で reject された場合、
     ユーザーには黒画面しか残らない（＝「再生されない」の体感そのもの）。
     load() で資源選択をやり直してから 1 度だけ play() を打ち直す。2 度目も駄目なら
     ネイティブ controls が残るので、ユーザーが自分で再生できる状態には必ず戻る
     （＝無限リトライにはしない・回線を殴らない）。 */
  function playModal(src, allowRetry){
    var p;
    try{ p = modalVid.play(); }catch(e){ p = null; }
    if(p && p.catch){
      p.catch(function(){
        if(!allowRetry) return;
        if(!modal.classList.contains('is-open')) return;   /* 既に閉じられていたら何もしない */
        if(modalVid.currentSrc && modalVid.currentSrc.indexOf(src) === -1) return;  /* 別の動画へ移っていたら何もしない */
        /* ★ load() は最後の手段 ★ 読み込みが**進んでいる最中**に load() を呼ぶと、そこまで
           貯めたバッファを捨てて最初からやり直しになる ―― 直そうとして遅くする典型。
           WebKit の実測でこれを踏んだ（初回計測で 17.8s の外れ値）。資源が本当に失われている
           とき（error が立っている / NETWORK_EMPTY ＝ そもそも何も掴んでいない）だけ建て直し、
           それ以外は play() をもう 1 度打つだけにする。 */
        if(modalVid.error || modalVid.networkState === 0){
          try{ modalVid.load(); }catch(e){}
        }
        playModal(src, false);
      });
    }
  }
  function closeVideo(){
    if(closing) return;
    closing = true;
    exitModalFullscreen();
    exitNativeVideoFullscreen();
    modalVid.pause();
    modalVid.removeAttribute('src');
    modalVid.load();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('video-open');
    if(scWasPlayingBeforeVideo && window.scWidget){
      try { window.scWidget.play(); } catch(e){}
    }
    scWasPlayingBeforeVideo = false;
    /* 2026-08-14 裁定④: タイマの手綱を持つ（openVideo が打ち切れるようにする）。値 400 は不変 */
    closeTimer = setTimeout(function(){ closing = false; closeTimer = null; }, 400);
  }

  /* bio 側の動画トリガ（オーバーレイ注入 DOM でも同じモーダルを使う・Batch 4 で実データが入る） */
  var bioVideoTriggers = document.querySelectorAll('.bio-video-trigger');
  Array.prototype.forEach.call(bioVideoTriggers, function(trigger){
    var src = trigger.getAttribute('data-video-src');
    if(!src) return;
    /* 2026-08-14 裁定④ ②: トリガの中にサムネイル 〈img〉 があれば、その画をそのままモーダルの
       poster に渡す（CLUB の 3 タイルが該当）。VISUAL のタイルは openVideo(v) の v.poster を
       既に持っているので、両者が同じ 1 つの引数に合流する ―― 分岐を増やしていない。 */
    var thumb = trigger.querySelector('img');
    var poster = thumb ? (thumb.currentSrc || thumb.src) : '';
    trigger.addEventListener('click', function(){ openVideo({ src:src, poster:poster }); });
  });

  function isLandscapeVideo(){
    return modalVid.videoWidth > 0 && modalVid.videoWidth > modalVid.videoHeight;
  }
  function syncOrientationFullscreen(){
    if(!modal.classList.contains('is-open')) return;
    if(!isLandscapeVideo()) return;
    var landscapeDevice = window.matchMedia && window.matchMedia('(orientation: landscape)').matches;
    if(landscapeDevice){
      enterNativeVideoFullscreen();
      requestModalFullscreen();
    } else {
      exitNativeVideoFullscreen();
      exitModalFullscreen();
    }
  }
  if(window.matchMedia){
    var orientationMql = window.matchMedia('(orientation: landscape)');
    if(orientationMql.addEventListener){ orientationMql.addEventListener('change', syncOrientationFullscreen); }
    else if(orientationMql.addListener){ orientationMql.addListener(syncOrientationFullscreen); }
  }
  window.addEventListener('orientationchange', syncOrientationFullscreen);
  modalVid.addEventListener('loadedmetadata', syncOrientationFullscreen);
  modalVid.addEventListener('ended', closeVideo);
  closeBtn.addEventListener('click', closeVideo);
  modal.addEventListener('click', function(e){
    if(e.target === modal) closeVideo();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && modal.classList.contains('is-open')) closeVideo();
  });
  ['fullscreenchange','webkitfullscreenchange'].forEach(function(ev){
    document.addEventListener(ev, function(){
      var isFs = document.fullscreenElement || document.webkitFullscreenElement;
      if(!isFs && modal.classList.contains('is-open')) closeVideo();
    });
  });
});

/* ==== [12] 原本 sections/asf-index.liquid L3538-3591 ==== */
/* ============================================================
   SCROLL RESTORATION — 【S3 Batch 6 で layout/theme.liquid へ昇格・本ファイルからは削除】

   Batch 1 の当該 IIFE には「demo では全ページ共通ブロック。theme-v3 では index セクション
   同梱に留める（保留リスト参照）」と明記していた。Batch 6 のクローム共通化に合わせて
   本来の全ページ挙動へ戻し、layout/theme.liquid のインライン 〈script〉 が
   window.__asfBootScrollRestore ガード付きで登録する（product / bio / legal / brand /
   vinyl / cart でもリロード・bfcache 復帰は必ず最上部から）。
   ★ ここに復活させないこと ★ 二重登録はガードで無害だが、真実源が2つになる。
============================================================ */

/* ==== [13] 原本 sections/asf-index.liquid L3594-3657 ==== */
/* ============================================================
   QUICK NAV — 全画面サイトマップパネル
   — 【S3 Batch 6 で snippets/asf-quicknav.liquid へ移設・本ファイルからは削除】

   Batch 6 のクローム共通化でパネルのマークアップが **全テンプレート**に出るようになった。
   制御 JS を index 専用の本ファイルに残すと、他ページでは「押しても何も起きない右下ボタン」に
   なる（＝機能的な死に体）。マークアップと制御を同じスニペットが持つ形へ寄せ、
   layout が全ページで1回だけ render する（window.__asfBootQuickNav ガードは維持）。
============================================================ */

/* ==== [14] 原本 sections/asf-index.liquid L3660-3778 ==== */
/*
  [theme-v3 / Batch 1] VISUAL 没入モード（無操作 5 秒で UI を消灯・操作で再表示）
  出典: demo-v3 index.html の同名 IIFE を **逐語移送**（ロジック無改変）。
  theme-v3 での唯一の変更は次の2点だけ:
    (1) window.asfBoot(...) で包む — このセクションは content_for_layout の中で描画され、
        demo のように </body> 直前で DOM が揃っている保証が無いため（§(h) h-5）。
    (2) window.__asfBootVisualIdle のシングルトン・ガード（二重マウント事故の構造的排除）。
  #visual の .is-active を hashchange で監視するだけ＝ハッシュルーターとは疎結合。
*/
window.asfBoot(function(){
  if (window.__asfBootVisualIdle) return;
  window.__asfBootVisualIdle = true;

/* ============================================================
   VISUAL 没入モード（2026-07-21(6) クライアント指示・2026-07-21(15) 改定）:
   VISUAL 進入 = コントローラー/写真ナンバー/クレジットを表示状態でスタート → 5秒後にフェード消灯 →
   操作（scroll / touchstart / touchmove / mousemove / keydown）でフェード再表示 →
   無操作 5秒で再消灯（旧 2.5秒・非表示スタートから変更）。コントローラーは同じ is-visual-idle
   駆動のため消灯タイミングは自動で同期。パネル開中は消灯しない。VISUAL 以外は現行挙動（非干渉）。
   rAF スロットリング + passive リスナー（軽量）。reduced-motion はサイト共通則で即時切替。
   hashchange はルーター（先に登録済み）→ 本ハンドラの順で同一タスク内に実行されるため、
   ビュー活性化と同フレームで同期 = 進入時のちらつきなし
============================================================ */
(function(){
  'use strict';
  var visualView = document.getElementById('visual');
  var quickRoot = document.getElementById('quickNav');
  if(!visualView) return;
  var IDLE_MS = 5000; /* 2026-07-21(15): 2.5秒 → 5秒 */
  var GRACE_MS = 700; /* 進入直後のプログラム的スクロール（ルーターの scrollTo / scrollIntoView）を
                         「操作」と誤認しないための猶予 — 進入時 hidden スタートを保証 */
  var body = document.body;
  var engaged = false, timer = null, ticking = false, engagedAt = 0;
  function panelOpen(){ return !!(quickRoot && quickRoot.classList.contains('is-open')); }
  /* 2026-07-21(33) バグ修正「スマホ版でクレジットだけ常時消えない」の真因と対策:
     真因 = opacity トランジションの凍結。setIdle のクラス切替がレンダリング休止中
     （アプリ切替・画面ロック・省電力などでフレーム供給が止まった瞬間）に起きると、
     CSS トランジションが開始値のまま凍結し computed opacity が 1 のまま残る
     （実測: is-visual-idle 付与下で pointer-events:none は即時適用 = ルール自体は
     当たっているのに opacity だけ 1 → 凍結の決定的証拠）。
     写真番号はカルーセル自動回転の textContent 更新、コントローラーはスクロール連動の
     クラス切替で毎回リスタイルされ凍結が偶発的に解除されるが、クレジットだけは以後
     一切リスタイルされず凍結が固定化 = 「クレジットだけ常時表示」のスマホ症状
     （モバイルはバックグラウンド化・ロック頻度が高く凍結機会が桁違いに多い）。
     対策 = settleFade(): 切替の .4s フェード完了後（600ms）に transition を一時無効化→
     強制リフロー→復元し、凍結していても必ず終端値（カスケード値）へ確定させる。
     健全な環境ではフェード完了後の no-op（見た目への影響なし）。
     対象は同時消灯仕様の3者 + コントローラー（インライン transition を持たない要素のみ = 安全） */
  var SETTLE_MS = 600;
  var settleTimer = null;
  function settleFade(){
    var els = document.querySelectorAll('.look-counter, .look-nav, .look-credits, .quicknav__btn');
    for(var i = 0; i < els.length; i++){
      els[i].style.transition = 'none';
      void els[i].offsetWidth; /* force reflow — 凍結遷移を破棄し終端値へ */
      els[i].style.transition = '';
    }
  }
  function setIdle(on){
    body.classList.toggle('is-visual-idle', on);
    if(settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(settleFade, SETTLE_MS);
  }
  function arm(){
    if(timer) clearTimeout(timer);
    timer = setTimeout(function(){
      timer = null;
      if(engaged && !panelOpen()) setIdle(true);
    }, IDLE_MS);
  }
  function wake(){
    setIdle(false);
    if(panelOpen()){ if(timer){ clearTimeout(timer); timer = null; } return; } /* パネル開中は消灯タイマー停止 */
    arm();
  }
  function onActivity(){
    if(!engaged || ticking) return;
    if(Date.now() - engagedAt < GRACE_MS) return; /* 進入直後の自動スクロールは無視 */
    ticking = true;
    /* rAF が休止する環境（省電力/バックグラウンド描画停止等）でも取り残されないよう、
       done ガード付き setTimeout(50ms) をフォールバックに併設 — quicknav スクロール連動と同型 */
    var done = false;
    function run(){ if(done) return; done = true; ticking = false; body.classList.remove('is-visual-ctrl-armed'); wake(); } /* 2026-07-26: 最初の実操作（GRACE 経過後の scroll/touch/mouse/key）でコントローラーの armed を解除し出現 → 以後は既存の没入/スクロール連動へ引き渡し */
    if(typeof requestAnimationFrame === 'function'){ requestAnimationFrame(run); }
    setTimeout(run, 50);
  }
  function sync(){
    var on = visualView.classList.contains('is-active');
    if(on === engaged) return;
    engaged = on;
    if(on) engagedAt = Date.now();
    body.classList.toggle('is-visual-mode', on);
    body.classList.toggle('is-visual-ctrl-armed', on); /* 2026-07-26 クライアント指示: VISUAL 進入時はコントローラーを非表示スタート（armed）。最初の実操作で onActivity が解除。退出(on=false)でも必ず解除しロック残留を防ぐ */
    if(timer){ clearTimeout(timer); timer = null; }
    setIdle(false); /* 2026-07-21(15): 進入 = 表示スタート（写真番号/クレジット側の挙動は不変）/ 退出 = 解除して通常挙動へ復帰。※コントローラーのみ上記 armed で進入時は隠す */
    if(on) arm();   /* 進入から IDLE_MS（5秒）で消灯（GRACE 内の自動スクロールはタイマー非リセット） */
  }
  ['scroll','touchstart','touchmove','mousemove','keydown'].forEach(function(ev){
    window.addEventListener(ev, onActivity, { passive:true });
  });
  window.addEventListener('hashchange', sync);
  /* 2026-07-21(31) バグ修正「クレジットが時間経過で消えなくなった」の真因と対策:
     onActivity の ticking ガードは rAF と setTimeout(50ms) の早着レースで解除される仕組みだが、
     タブがバックグラウンド化（他アプリ切替・画面ロック・タブスイッチ等）した瞬間に活動イベントが
     発生していると、両者とも発火せず ticking=true のまま永久に固着しうる（rAF はバックグラウンドで
     完全停止・setTimeout も同様に凍結され得る）。固着後は onActivity 冒頭の早期リターンで以後の
     操作が一切無視され、wake()/arm() サイクルが停止 = 消灯・再表示ともその時点の状態で固まる
     （カルーセル側は既存の visibilitychange 復帰処理（schedule 再開）で同種の問題に対処済みだが、
     本没入スクリプトには同等の保険が無かった）。復帰時に ticking を強制リセットし wake() で
     再同期することで、固着状態からも必ず正しい消灯/再表示サイクルへ復帰させる */
  document.addEventListener('visibilitychange', function(){
    ticking = false;
    if(!document.hidden && engaged){ wake(); }
  });
  sync();
})();
});

/* ==== [15] 原本 sections/asf-index.liquid L3781-3816 ==== */
/*
  [theme-v3 / Batch 1] LOOK ステージ上では右下クイックナビ / 左下グローバルボタンを隠す
  出典: demo-v3 index.html の同名 IIFE を **逐語移送**（ロジック無改変）。
  theme-v3 での唯一の変更は次の2点だけ:
    (1) window.asfBoot(...) で包む — このセクションは content_for_layout の中で描画され、
        demo のように </body> 直前で DOM が揃っている保証が無いため（§(h) h-5）。
    (2) window.__asfBootLookStage のシングルトン・ガード（二重マウント事故の構造的排除）。
  body.is-look-stage-visible を付けるだけ。実際に隠すのは asf-theme.css 側の規則。
*/
window.asfBoot(function(){
  if (window.__asfBootLookStage) return;
  window.__asfBootLookStage = true;

/* ============================================================
   VISUAL LOOK ステージ上のコントローラー隠し（2026-07-26 クライアント指示・原文要旨引用
   「VISUAL の LOOK 写真の上では、右下のコントローラーと左下の再生ボタンを両方隠す。写真を通過したら元に戻す」）
   - LOOK ステージ（.look-stage-wrap）がビューポートと交差している間だけ body.is-look-stage-visible を付与し、
     <head> 内 CSS が右下 .quicknav__btn と左下 .global-play を両方 opacity:0/pointer-events:none に。交差解除で自動復帰。
   - 状態取り残しゼロ: ①交差解除で isIntersecting=false → クラス除去 ②VISUAL 退出時は #visual が display:none となり
     ステージも非描画＝intersectionRatio 0 で isIntersecting=false が発火し解除 ③タブ復帰で IO 自動再評価。他ビューは
     ステージ非交差のためクラス非付与＝不変。音声層・排他・プレイヤーには一切触れない（純粋に可視性のみ）。
   - IntersectionObserver 非対応環境はスキップ（クラス非付与＝コントローラー既存表示のまま＝無害フォールバック）。
============================================================ */
(function(){
  'use strict';
  var stage = document.querySelector('.look-stage-wrap');
  if(!stage || !('IntersectionObserver' in window)) return;
  var body = document.body;
  var io = new IntersectionObserver(function(entries){
    for(var i=0;i<entries.length;i++){ body.classList.toggle('is-look-stage-visible', entries[i].isIntersecting); }
  }, { root:null, threshold:0 });
  io.observe(stage);
})();
});

/* ==== [16] 原本 sections/asf-index.liquid L3819-3846 ==== */
/* ============================================================
   A.S.F. List フォームの「実 POST 実装までの実ナビゲーション封じ」
   — 【S3 Batch 6 で撤去】

   Batch 1 の当該 IIFE は自身のコメントで「★ 削除タイミング ★ Batch 6 で .list-form に
   実 POST ハンドラを付けたら、この IIFE ごと撤去する」と宣言していた。予定どおり撤去。
   実装は snippets/asf-list-form.liquid（part:'script'）が全ページ常駐の submit 委譲として持ち、
   form_type=customer の /contact POST を fetch で行い、2xx 成功時に GA list_signup_intent を
   発火する（§(c) mailing-list 文法 / §(d) ruling #7 の昇格発火点）。
============================================================ */

/* ==== [17] 2026-07-30 撤去 — A.S.F.RECS 3D ロゴ。番号 [17] は欠番のまま（[16] が最終ブロック）。撤去理由は snippets/asf-tab-label.liquid の該当箇所コメント。 ==== */

/* ==== [18] 2026-08-14 裁定④ — CLUB 動画 3 本の「先頭ヘッド温め」 ====
   ============================================================
   ★ 裁定（逐語）★「一番左のビデオはすぐに再生されるが、中央と右の動画は再生されない、
     されるまで時間がかかる、たまに再生される。修正してください」

   ★ 実測で判った素材側の事実（3 本の構造に差は無い）★
     ・data-video-src の Liquid 出力は 3 本とも 1 バイト同一（余分な改行・空白の混入ゼロ）
     ・3 本とも faststart 済み（ftyp の直後が moov）。moov 終端は
         club-michelle-1 … 121,830 B ／ -2 … 76,462 B ／ -3 … 55,338 B
       ＝ **左が最も重い**。「左だけ速い」を素材側で説明できる差は無い。
     ・Vercel エッジは 3 本とも x-vercel-cache:HIT・accept-ranges:bytes・
       cache-control:public, max-age=31536000, immutable。CDN 差も無い。
     ・本体サイズは 16.4MB / 16.3MB / 10.7MB（右が最軽量なのに右が遅い＝サイズとも無相関）。
   ★ よって原因はクライアント側の 2 つ ★
     ① 閉じた直後の再入で play() が中断され、無言で握りつぶされていた（→ openVideo 側で対処済み）
     ② **ブラウザ HTTP キャッシュの温度差**。preload="none" のためタップまで 1 バイトも
        落ちない設計で、一度観た 1 本だけが immutable キャッシュに残る。ユーザーは必ず
        左から押すので、左だけが常に温まっている状態が再現される ―― これが体感の主因。

   ★ 直し方は音源で確立済みの手を横に移すだけ（新発明ゼロ）★
     snippets/asf-audio-layer.liquid の warmNext / warmHead（WARM_CHUNK=262144・
     Range 256KB 刻み・206 以外は即破棄・force-cache・saveData/2g は不参加・
     userAgentData のあるエンジン限定）を、そのままの条件で動画 3 本へ適用する。
     温める量は 512KB 固定 ―― 3 本の moov 最大値 121,830 B を確実に含み、
     その先の mdat 頭も少し咥えるので「押した瞬間にメタデータが既にある」状態になる。
   ★ 費用 ★ 3 本 × 512KB = 1.5MB。音源側で既に許容されている予算と同族。
     saveData / 2g / 非 Blink では **1 バイトも取りに行かない**（改修前と完全に同じ挙動）。
   ★ 発火 ★ CLUB が実際に開かれた後のアイドル時のみ。初期表示とは競合させない。
   ★ 音は鳴らない ★ fetch でバイトを HTTP キャッシュへ載せるだけで、
     〈video〉 も 〈audio〉 も 1 つも作らない・play() も呼ばない。
============================================================ */
(function(){
  var HEAD  = 524288;   /* 512KB。3 本の moov 最大 121,830B を包含する */
  var CHUNK = 262144;   /* 256KB。中断の粒度＝捨てる可能性のある最大量（音源側と同値） */

  /* fetch のキャッシュをメディア要素が再利用することを音源側で実測できたエンジンだけ温める */
  var CAN_WARM = !!(navigator.userAgentData);

  function netAllows(){
    try{
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if(!c) return true;
      if(c.saveData) return false;
      if(c.effectiveType === '2g' || c.effectiveType === 'slow-2g') return false;
    }catch(e){}
    return true;
  }
  function onIdle(fn){
    if(window.requestIdleCallback) window.requestIdleCallback(fn, { timeout:3000 });
    else setTimeout(fn, 1200);
  }

  var jobs = [];        /* { src, warmedTo } */
  var busy = false;
  var started = false;

  function step(job){
    if(job.warmedTo >= HEAD){ busy = false; next(); return; }
    var from = job.warmedTo, to = Math.min(HEAD, from + CHUNK) - 1;
    fetch(job.src, {
      headers: { 'Range': 'bytes=' + from + '-' + to },
      cache: 'force-cache',
      mode: 'cors'
    }).then(function(r){
      /* ★ 206 以外は必ず捨てる ★ Range を無視するホストへ移した場合、200 で本体 16MB が
         返ってくる。本文を読まずに打ち切り、この 1 本は以後温めない（＝従来どおりタップ時に取りに行く）。 */
      if(r.status !== 206){ try{ if(r.body) r.body.cancel(); }catch(e){} job.warmedTo = HEAD; return null; }
      return r.arrayBuffer();
    }).then(function(buf){
      if(!buf){ busy = false; next(); return; }
      job.warmedTo = from + buf.byteLength;
      step(job);
    }).catch(function(){ busy = false; next(); });   /* 失敗は打ち切り。落ちた分はキャッシュに残るので無害 */
  }
  function next(){
    if(busy) return;
    var job = null;
    for(var i=0;i<jobs.length;i++){ if(jobs[i].warmedTo < HEAD){ job = jobs[i]; break; } }
    if(!job) return;
    busy = true;
    step(job);
  }

  function collect(){
    var out = [], seen = {};
    var nodes = document.querySelectorAll('#club .np-video-tile[data-video-src]');
    for(var i=0;i<nodes.length;i++){
      var s = nodes[i].getAttribute('data-video-src');
      if(!s || seen[s]) continue;
      seen[s] = 1;
      out.push({ src:s, warmedTo:0 });
    }
    return out;
  }

  function boot(){
    if(started) return;
    if(!CAN_WARM || typeof fetch !== 'function' || !netAllows()) return;
    var found = collect();
    if(!found.length) return;
    started = true;
    jobs = found;
    next();
  }

  /* CLUB が実際に開かれてからのアイドル時にだけ走らせる（初期表示と帯域を取り合わない）。
     ルーターはビュー切替で #club に .is-active を付け外しするので、その状態だけを見る。 */
  function clubActive(){
    var el = document.getElementById('club');
    return !!(el && el.classList.contains('is-active'));
  }
  function arm(){
    if(started) return;
    if(!clubActive()) return;
    onIdle(boot);
  }
  if(document.readyState === 'complete') arm();
  else window.addEventListener('load', arm);
  window.addEventListener('hashchange', arm);
  /* ルーターがハッシュ無しでビューを切り替える経路の保険（タブのクリックを拾うだけ・1 回で足りる） */
  document.addEventListener('click', function(){ setTimeout(arm, 0); }, { passive:true, capture:true });
})();
